const proj4 = require('proj4').default;
const Spinner = require('spin.js');
/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var SD = SD || {};
SD.Bookmark = SD.Bookmark || {};
SD.Bookmark.Shared = SD.Bookmark.Shared || {};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
SD.Bookmark.CreateInstance = function CreateInstance(guidBookmark,
                                                     strBookmarkName,
                                                     guidUser,
                                                     guidGeographicSpatialReference,
                                                     decExtentMinX,
                                                     decExtentMinY,
                                                     decExtentMaxX, 
                                                     decExtentMaxY) {

    // Create the object that will hold the instance properties ...
    var objBookmark = {
        BookmarkID: guidBookmark,
        BookmarkName: strBookmarkName,
        UserID: guidUser,
        GeographicSpatialReferenceID: guidGeographicSpatialReference, 
        ExtentMinX: decExtentMinX, 
        ExtentMinY: decExtentMinY,
        ExtentMaxX: decExtentMaxX,
        ExtentMaxY: decExtentMaxY,

        ToEsriMapExtent: SD.Bookmark.ToEsriMapExtent,
        UpdateFromEsriMapExtent: SD.Bookmark.UpdateFromEsriMapExtent
    };

    return objBookmark;
}

// **************************************************************************
// FUNCTION: AddFunctionsToServerSideObject
// USAGE:    Adds the functions to an instance obtained from the server side ...
// **************************************************************************
SD.Bookmark.Shared.AddFunctionsToServerSideObject = function AddFunctionsToServerSideObject(objBookmark) {

    // Add the fucntions to the instance ...
    objBookmark.ToEsriMapExtent = SD.Bookmark.ToEsriMapExtent;
    objBookmark.UpdateFromEsriMapExtent = SD.Bookmark.UpdateFromEsriMapExtent;
}

// **************************************************************************
// FUNCTION: CreateFromEsriMapExtent
// USAGE:    Creates an SD bookmark using the values from the provided esri extent ...
// **************************************************************************
SD.Bookmark.Shared.CreateFromEsriMapExtent = function CreateFromEsriMapExtent(objEsriMapExtent, strBookmarkName, guidUser, guidGeographicSpatialReference) {

    // Create a SD bookmark using the values from the provided esri extent ...
    var objBookmark = SD.Bookmark.CreateInstance(SD.Guid.Shared.NewID(),
                                                 strBookmarkName,
                                                 guidUser,
                                                 guidGeographicSpatialReference,
                                                 objEsriMapExtent.xmin,
                                                 objEsriMapExtent.ymin,
                                                 objEsriMapExtent.xmax,
                                                 objEsriMapExtent.ymax);

    return objBookmark;
}

// **************************************************************************
// FUNCTION: ToEsriMapExtent
// USAGE:    
// **************************************************************************
SD.Bookmark.ToEsriMapExtent = function ToEsriMapExtent(strSpatialReferenceWKT) {

    // Get the instance ...
    var objBookmarkInstance = this;

    // Declare a variable for the esri spatial reference ...
    var objEsriSpatialReference;

    // When strSpatialReferenceWKT has been provided ...
    if (typeof strSpatialReferenceWKT != 'undefined') {

        // Create the esri spatial reference from the well know text definition ...
        objEsriSpatialReference = new esri.SpatialReference(strSpatialReferenceWKT);
    }
    
    // Create the esri spatial reference ...
    var objEsriMapExtent = esri.geometry.Extent(objBookmarkInstance.ExtentMinX,
                                                objBookmarkInstance.ExtentMinY,
                                                objBookmarkInstance.ExtentMaxX,
                                                objBookmarkInstance.ExtentMaxY,
                                                objEsriSpatialReference);

    return objEsriMapExtent;
}


// **************************************************************************
// FUNCTION: UpdateFromEsriMapExtent
// USAGE:    
// **************************************************************************
SD.Bookmark.UpdateFromEsriMapExtent = function UpdateFromEsriMapExtent(objEsriMapExtent, guidSpatialReference) {

    // Get the instance ...
    var objBookmarkInstance = this;

    // Set the extent values ...
    objBookmarkInstance.ExtentMinX = objEsriMapExtent.xmin;
    objBookmarkInstance.ExtentMinY = objEsriMapExtent.ymin;
    objBookmarkInstance.ExtentMaxX = objEsriMapExtent.xmax;
    objBookmarkInstance.ExtentMaxY = objEsriMapExtent.ymax;

    // When we have a spatial reference ID ...
    if ((typeof guidSpatialReference != 'undefined') && (guidSpatialReference != null)) {

        // Set the spatial reference ID ...
        objBookmarkInstance.GeographicSpatialReferenceID = guidSpatialReference;
    }    
}


// Create the SD namespace object (if it does not exist already) ...
var SD = SD || {};

// Create the DisplayValue object ...
SD.DisplayValue = SD.DisplayValue || {};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION FromDecimal : Function to display a double value using the group and
//                        decimal separators and the number of decimal places ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.DisplayValue.FromDouble = function FromDouble(dblValue, strGroupSeparator, strDecimalSeparator, intDecimalPlaces) {

    // Round the value to the number of decimal places if specified ...
    let dblRoundedValue = ((typeof intDecimalPlaces != 'undefined') && (intDecimalPlaces != null) && (intDecimalPlaces != SD.Number.NULL_NUMBER)) ? SD.Number.RoundTo(dblValue, intDecimalPlaces) : dblValue;

    // Convert the value to a string ...
    var strValue = String(dblRoundedValue);

    // Split the value into it's whole and decimal parts ..
    var arrValueParts = strValue.split(".");

    // Get the whole part ...
    var strWholePart = arrValueParts[0];

    // Determine whether or not the value is negative ...
    var blnIsNegative = (dblValue < 0);

    // Remove the sign from the whole part when negative ...
    if (blnIsNegative) { strWholePart = strWholePart.substr(1); }

    // Start with an empty string ...
    var strResult = "";

    // While we have more than 3 digits left from the whole part ...
    while (strWholePart.length > 3) {

        // When we have no result string so far ...
        if (strResult.length == 0) {

            // Start with the next 3 digits from the right ...
            strResult = strWholePart.substr(strWholePart.length - 3, 3);

        } else {

            // Append the next 3 digits from the right with the group separator ...
            strResult = strWholePart.substr(strWholePart.length - 3, 3) + strGroupSeparator + strResult;
        };

        // Get the remaining whole part characters ...
        strWholePart = strWholePart.substr(0, strWholePart.length - 3);
    };

    // When we still have whole digits left ...
    if (strWholePart.length > 0) {

        // When we have no result string so far ...
        if (strResult.length == 0) {

            // Start with the whole part ...
            strResult = strWholePart;

        } else {

            // Append the remaining whole digits with the group separator ...
            strResult = strWholePart + strGroupSeparator + strResult;
        };
    };

    // When we have a decimal part ...
    if (arrValueParts.length > 1) {

        // Get the decimal part ...
        var strDecimalPart = arrValueParts[1];

        // Append the decimal part to the result ...
        strResult += strDecimalSeparator + strDecimalPart;

        // When the number of decimal places were passed in and we have less digits in the decimal part than intDecimalPlaces ...
        if ((typeof intDecimalPlaces != 'undefined') && (strDecimalPart.length < intDecimalPlaces)) {

            // Zero pad at the end to fill the number of required deimal places
            // The join function joins all the elements of an array into a string with the parameter '0' as the separator ...
            strResult += Array(intDecimalPlaces + 1 - strDecimalPart.length).join('0');
        };
    }
    else {

        // When the number of decimal places were passed in and deimcal places are required ....
        if ((typeof intDecimalPlaces != 'undefined') && (intDecimalPlaces > 0)) {

            // Add the separator ...
            strResult += strDecimalSeparator;

            // Zero pad for the number of required decimal places 
            // The join function joins all the elements of an array into a string with the parameter '0' as the separator ...
            strResult += Array(intDecimalPlaces + 1).join('0');
        };
    };
        
    // Add the sign back when negative ...
    strResult = ((blnIsNegative) ? '-' : '') + strResult;

    // Return the value ...
    return strResult;
}

SD.DisplayValue.FromDate = function FromDate(date, format, options) {
    
    /**
    * Date Format
    * Copyright (c) 2011, marlun78
    * MIT License, https://gist.github.com/marlun78/bd0800cf5e8053ba9f83
    *
    * Format options inspired by the .NET framework's format.
    * http://msdn.microsoft.com/en-us/library/8kb3ddd4.aspx
    *
    * Non-formatting characters within the format string must be
    * quoted (single (') or double (") quotes)! The same is true
    * for two format specifiers that should apear together. Eg.
    * if you want the date to be output with the date ordinal
    * (9th), the format string must be "d''x" (or 'd""x').
    *
    * Arguments:
    *     format   {String} The format pattern to display the date in. See Format Patterns section below for options.
    *     settings {Object} Formatting settings.
    *
    * Settings:
    *     asUtc      {Boolean} If the formatted date is to be returned as a UTC date.
    *     days       {Array}   The days of the week. Starting with Sunday.
    *     daysAbbr   {Array}   The days of the week, abbreviated. Starting with Sunday.
    *     designator {Array}   Time designator. Starting with AM.
    *     format     {String}  The format pattern to format the date in.
    *     months     {Array}   The name of the months. Starting with January.
    *     monthsAbbr {Array}   The name of the months, abbreviated. Starting with January.
    *
    * Format Patterns:
    *      d       1-31                The day of the month
    *      dd      01-31               The day of the month
    *      ddd     Mon-Sun             The abbreviated name of the day of the week
    *      dddd    Monday-Sunday       The full name of the day of the week
    *      f       6                   The tenths of a second in a date and time value. The remaining digits are truncated.
    *      ff      61                  The hundredths of a second in a date and time value. The remaining digits are truncated.
    *      fff     617                 The milliseconds in a date and time value. The remaining digits are truncated.
    *      ffff    6170                The milliseconds in a date and time value, with a trailing zero. The remaining digits are truncated.
    *      fffff   61700               The milliseconds in a date and time value, with two trailing zeros. The remaining digits are truncated.
    *      ffffff  617000              The milliseconds in a date and time value, with three trailing zeros. The remaining digits are truncated.
    *      F       6                   The tenths of a second in a date and time value. Trailing zeros or zero values are not displayed.
    *      FF      61                  The hundredths of a second in a date and time value. Trailing zeros or zero values are not displayed.
    *      FFF     617                 The milliseconds in a date and time value. Trailing zeros or zero values are not displayed.
    *      FFFF    617                 The milliseconds in a date and time value. Trailing zeros or zero values are not displayed.
    *      FFFFF   617                 The milliseconds in a date and time value. Trailing zeros or zero values are not displayed.
    *      FFFFFF  617                 The milliseconds in a date and time value. Trailing zeros or zero values are not displayed.
    *      h       1-12                The hour, using a 12-hour clock
    *      hh      01-12               The hour, using a 12-hour clock
    *      H       0-23                The hour, using a 24-hour clock
    *      HH      00-23               The hour, using a 24-hour clock
    *      m       0-59                The minute
    *      mm      00-59               The minute
    *      M       1-12                The month
    *      MM      01-12               The month
    *      MMM     Jan-Dec             The abbreviated name of the month
    *      MMMM    January-December    The full name of the month
    *      s       0-59                The second
    *      ss      00-59               The second
    *      tt      AM/PM               The AM/PM designator
    *      x       st, nd, rd, th      The ordinal suffix of a number (NOTE! This does not exist in .NET!)
    *      y       0-99                The year
    *      yy      00-99               The year
    *      yyy     001-9999            The year, with a minimum of three digits
    *      yyyy    0001-9999           The year as a four-digit number
    *      z       +1                  Hours offset from UTC, with no leading zeros.
    *      zz      +01                 Hours offset from UTC, with a leading zero for a single-digit value.
    *      zzz     +01:00              Hours and minutes offset from UTC.
    *
    * Example:
    *     The formatting method can be called in the following three ways:
    *     formatDate(format, settings) {String} The format string passed is used, any settings are stored.
    *                                           If the settings object contain a format property, it will override the format string.
    *     formatDate(settings)         {String} Settings are stored and the stored format is used.
    *     formatDate()                 {String} Default settings are used.
    */

    var asUtc = false,
        days = 'Sunday Monday Tuesday Wednesday Thursday Friday Saturday'.split(' '),
        daysAbbr = 'Sun Mon Tue Wed Thu Fri Sat'.split(' '),
        designators = 'AM PM'.split(' '),
        defaultFormat = 'MMMM d""x "at" h:mm tt',
        months = 'January February March April May June July August September October November December'.split(' '),
        monthsAbbr = 'Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec'.split(' '),

        // The formatting function
        formatDate = (function () {
            var findPatterns = /([dfFhmHMstxyz]+)(?=([^"']*["'][^"']*["'])*[^"']*$)/g,
                getMethod = function (method) {
                    return 'get' + (asUtc ? 'UTC' : '') + method;
                },
                handlers = {
                    d: function () { return this[getMethod('Date')](); },
                    dd: function () { return pad(this[getMethod('Date')]()); },
                    ddd: function () { return getDayName.call(this, true); },
                    dddd: function () { return getDayName.call(this); },
                    f: function () { return pad(pad(this[getMethod('Milliseconds')](), 3), 6, true).substr(0, 1); },
                    ff: function () { return pad(pad(this[getMethod('Milliseconds')](), 3), 6, true).substr(0, 2); },
                    fff: function () { return pad(pad(this[getMethod('Milliseconds')](), 3), 6, true).substr(0, 3); },
                    ffff: function () { return pad(pad(this[getMethod('Milliseconds')](), 3), 6, true).substr(0, 4); },
                    fffff: function () { return pad(pad(this[getMethod('Milliseconds')](), 3), 6, true).substr(0, 5); },
                    ffffff: function () { return pad(pad(this[getMethod('Milliseconds')](), 3), 6, true).substr(0, 6); },
                    F: function () { var r = pad(this[getMethod('Milliseconds')](), 3).substr(0, 1); return r === '0' ? '' : r; },
                    FF: function () { var r = pad(this[getMethod('Milliseconds')](), 3).substr(0, 2); return r === '00' ? '' : r; },
                    FFF: function () { return pad(this[getMethod('Milliseconds')](), 3).substr(0, 3); },
                    FFFF: function () { return handlers.FFF.call(this); },
                    FFFFF: function () { return handlers.FFF.call(this); },
                    FFFFFF: function () { return handlers.FFF.call(this); },
                    h: function () { var h = this[getMethod('Hours')](); return h > 12 ? h - 12 : h; },
                    hh: function () { var h = this[getMethod('Hours')](); return pad(h > 12 ? h - 12 : h); },
                    m: function () { return this[getMethod('Minutes')](); },
                    mm: function () { return pad(this[getMethod('Minutes')]()); },
                    H: function () { return this[getMethod('Hours')](); },
                    HH: function () { return pad(this[getMethod('Hours')]()); },
                    M: function () { return this[getMethod('Month')]() + 1; },
                    MM: function () { return pad(this[getMethod('Month')]() + 1); },
                    MMM: function () { return getMonthName.call(this, true); },
                    MMMM: function () { return getMonthName.call(this); },
                    s: function () { return this[getMethod('Seconds')](); },
                    ss: function () { return pad(this[getMethod('Seconds')]()); },
                    tt: function () { return getDesignator.call(this); },
                    x: function () { return getOrdinal.call(this); },
                    y: function () { var y = this[getMethod('FullYear')](), s = y.toString(); return y < 10 ? y : s.substr(s.length - 2); },
                    yy: function () { return pad(this[getMethod('FullYear')](), 2); },
                    yyy: function () { var y = this[getMethod('FullYear')](), s = y.toString(); return y < 1000 ? pad(y, 3) : s.substr(s.length - 4); },
                    yyyy: function () { return pad(this[getMethod('FullYear')](), 4); },
                    yyyyy: function () { return pad(this[getMethod('FullYear')](), 5); },
                    yyyyyy: function () { return pad(this[getMethod('FullYear')](), 6); },
                    z: function () { var t = this.getTimezoneOffset(); return (t > 0 ? '-' : '+') + Math.abs(t / 60); },
                    zz: function () { var t = this.getTimezoneOffset(); return (t > 0 ? '-' : '+') + pad(Math.abs(t / 60)); },
                    zzz: function () { var t = this.getTimezoneOffset(); return (t > 0 ? '-' : '+') + pad(Math.abs(t / 60)) + ':' + pad((Math.abs(t / 60) % 1) * 60); }
                };

            return function () {
                var self = this, format, settings;
                // Evaluate arguments
                if (typeof arguments[0] === 'string') {
                    format = arguments[0];
                    settings = arguments[1];
                }
                else {
                    format = null;
                    settings = arguments[0];
                }
                // Store any passed settings
                if (settings) {
                    if (typeof settings.asUtc !== 'undefined') asUtc = settings.asUtc;
                    if (settings.days) days = settings.days;
                    if (settings.daysAbbr) daysAbbr = settings.daysAbbr;
                    if (settings.designator) designators = settings.designator;
                    if (settings.format) defaultFormat = settings.format;
                    if (settings.getDateOrdinal) getOrdinal = settings.getDateOrdinal;
                    if (settings.months) months = settings.months;
                    if (settings.monthsAbbr) monthsAbbr = settings.monthsAbbr;
                }
                if (!format) {
                    format = defaultFormat;
                }
                return format.replace(findPatterns, function (match, group1) {
                    var fn = handlers[group1];
                    return typeof fn === 'function' ? fn.call(self) : match;
                }).replace(/["']/g, '');
            };
        }()),
        
        getDayName = function (asAbbr) {
            var n = this.getDay();
            return asAbbr ? daysAbbr[n] : days[n];
        },

        getMonthName = function (asAbbr) {
            var n = this.getMonth();
            return asAbbr ? monthsAbbr[n] : months[n];
        },

        getOrdinal = (function () {
            var os = 'th st nd rd th'.split(' ');
            return function () {
                var d = this.getDate();
                return (d > 3 && d < 21) ? os[0] : os[Math.min(d % 10, 4)];
            };
        }()),

        getDesignator = function () {
            return this.getHours() >= 12 ? designators[1] : designators[0];
        },

        pad = (function () {
            var p = '000000';
            return function (obj, len, fromRight) {
                return fromRight ?
                    (obj + p).slice(0, len ? Math.min(len, p.length) : 2) :
                    (p + obj).slice(-(len ? Math.min(len, p.length) : 2));
            };
        }());

    // Expose the formatting method
    // As a global function
    //window.formatDate = function (date, format, options) {
    //    if(isNaN(+date) || !date.getDate) throw new Error('Not a valid date');
    //    return formatDate.call(date, format, options);
    //};
    // Or as a method on the Date object
    Date.prototype.format = function (format, options) {
        return formatDate.call(this, format, options);
    };

    return formatDate.call(date, format, options);
}

SD.DisplayValue.FromDateAsString = function FromDateAsString(date, format, options) {
    return SD.DisplayValue.FromDate(new Date(date), format, options);
}

SD.DisplayValue.GetJQueryDateFormatFromDotNetFormat = function (format) {
    let jqueryFormat = '';
    
    jqueryFormat = format
        .replace('MMMM', '{temp month 1}')
        .replace('MMM', '{temp month 2}')
        .replace('MM', 'mm')
        .replace('M', 'm')
        .replace('{temp month 1}', 'MM')
        .replace('{temp month 2}', 'M')
        .replace('dddd', 'DD')
        .replace('ddd', 'D')
        .replace('yyyy', '{temp year 1}')
        .replace('yy', 'y')
        .replace('{temp year 1}', 'yy');

    return jqueryFormat;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the Map namespace ...
SD.DMS = SD.DMS || {};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ToDMS
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.DMS.ToDMS = function ToDMS(decLatitudeDecimalDegrees, decLongitudeDecimalDegrees, strGroupSeparator, strDecimalSeparator, intDecimalPlaces) {

    // Get the North, South, East and West translations ...
    var strN = SD.Translation.Shared.GetTranslation('SD.DMS.js', 'NorthAbbreviation');
    var strS = SD.Translation.Shared.GetTranslation('SD.DMS.js', 'SouthAbbreviation');
    var strE = SD.Translation.Shared.GetTranslation('SD.DMS.js', 'EastAbbreviation');
    var strW = SD.Translation.Shared.GetTranslation('SD.DMS.js', 'WestAbbreviation');

    // Convert the ordinates to DMS ....
    var objLatitudeDMS = SD.DMS.OrdinateToDMS(decLatitudeDecimalDegrees, strN, strS, strGroupSeparator, strDecimalSeparator, intDecimalPlaces);
    var objLongitudeDMS = SD.DMS.OrdinateToDMS(decLongitudeDecimalDegrees, strE, strW, strGroupSeparator, strDecimalSeparator, intDecimalPlaces);

    // Build an object with the latitude and longitude dms values ...
    var objDMS = {
        Latitude: objLatitudeDMS.DMS,
        Longitude: objLongitudeDMS.DMS,

        LatitudeDegrees: objLatitudeDMS.Degrees,
        LatitudeMinutes: objLatitudeDMS.Minutes,
        LatitudeSeconds: objLatitudeDMS.Seconds,
        NorthSouth: objLatitudeDMS.Direction,

        LongitudeDegrees: objLongitudeDMS.Degrees,
        LongitudeMinutes: objLongitudeDMS.Minutes,
        LongitudeSeconds: objLongitudeDMS.Seconds,
        EastWest: objLongitudeDMS.Direction
    }

    return objDMS;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION OrdinateToDMS
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.DMS.OrdinateToDMS = function OrdinateToDMS(decDecimalDegrees, strPositiveDirection, strNegativeDirection, strGroupSeparator, strDecimalSeparator, intDecimalPlaces) {

    // Determine the direction based on the sign of the ordinate value ...
    var strDirection = (decDecimalDegrees >= 0) ? strPositiveDirection : strNegativeDirection;

    // Convert to a positive number ...
    decDecimalDegrees = Math.abs(decDecimalDegrees);

    // Convert to dms ...
    var strDegrees = SD.DMS.GetDegrees(decDecimalDegrees);
    var strMinutes = SD.DMS.GetMinutes(decDecimalDegrees);
    var strSeconds = SD.DMS.GetSeconds(decDecimalDegrees, strDecimalSeparator, intDecimalPlaces);

    // When the seconds works out to 60 ...
    if (strSeconds == '60') {

        // Use 0 seconds ...
        strSeconds = '00';

        // Increment the minutes with 1 ...
        strMinutes = String(SD.Number.ToNumber(strMinutes, strGroupSeparator, strDecimalSeparator) + 1);
    }

    // When the minutes works out to 60 ...
    if (strMinutes == '60') {

        // Use 0 minutes ...
        strMinutes = '00';

        // Increment the degrees with 1 ...
        strDegrees = String(SD.Number.ToNumber(strDegrees, strGroupSeparator, strDecimalSeparator) + 1);
    }

    // Build the dms string ...
    var strDMS = strDegrees + '°' + strMinutes + "'" + strSeconds + '" ' + strDirection;

    // Build an object with the converted values ...
    var objDMS = {
        DMS: strDMS,
        Degrees: strDegrees,
        Minutes: strMinutes,
        Seconds: strSeconds,
        Direction: strDirection
    }

    return objDMS;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetDegrees
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.DMS.GetDegrees = function GetDegrees(decDecimalDegrees) {
    return SD.String.ZeroPad(String(SD.Number.Truncate(decDecimalDegrees)), 2);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetMinutes
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.DMS.GetMinutes = function GetMinutes(decDecimalDegrees) {
    return SD.String.ZeroPad(String(SD.Number.Truncate(Math.abs(decDecimalDegrees) * 60.0) % 60.0), 2);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetSeconds
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.DMS.GetSeconds = function GetSeconds(decDecimalDegrees, strDecimalSeparator, intGeographicSecondsDecimalPlaces) {
    return SD.String.ZeroPad(SD.DisplayValue.FromDouble(SD.Number.RoundTo((Math.abs(decDecimalDegrees) * 3600.0) % 60.0, intGeographicSecondsDecimalPlaces), '', strDecimalSeparator), 2 + intGeographicSecondsDecimalPlaces);
}


// Create the SD namespace object (if it does not exist already) ...
var SD = SD || {};

// Create the Number object ...
SD.DOM = SD.DOM || {
   
};

SD.DOM.ElementIDsToExclude =  [];

// **************************************************************************
// FUNCTION: AddElementIDToExcludeFromMaxZIndex
// USAGE:    Add element ID's that cause problems with the SD.DOM.BringToFront(), to exclude them in the MaxZIndex(). 
//           This prevents ZIndex's hitting the max integer number.
// **************************************************************************
SD.DOM.AddElementIDToExcludeFromMaxZIndex = function AddElementIDToExcludeFromMaxZIndex(strIDToExclude) {
    if (SD.DOM.ElementIDsToExclude != null) {
        SD.DOM.ElementIDsToExclude.push(strIDToExclude);
    }
    else {
        SD.DOM.ElementIDsToExclude = [];
        SD.DOM.ElementIDsToExclude.push(strIDToExclude);
    }
}

SD.DOM.ReloadPage = function ReloadPage() {
    window.location.reload(true);
}

//----------------Resize Comboboxes to be the same width as textboxes----------------------------
SD.DOM.SizeListBox = function SizeListBox(strListboxID, intPadding) {
    var intMaxWidth = 0;

    $(document).ready(function () {
        $('#' + strListboxID + ' option').each(function () {
            //insert a temporary <span> with the same CSS class and same text into the document body
            $('body').prepend('<span id="widthTest" >' + this.innerHTML + '</span>');
            //measure the width of the temporary span
            var textWidth = $('#widthTest').width();
            //remove the temporary span
            $('#widthTest').remove();
            //resize the tab button to the calculated width (plus some padding)
            if (intMaxWidth < textWidth) {
                intMaxWidth = textWidth;
            }

        });

        $('#' + strListboxID).width(intMaxWidth + intPadding);
    });
}

SD.DOM.EnableControl = function EnableControl(strTextBoxID, strCheckBoxID, blnCheckBoxChecked) {
    var objTextBox = $('#' + strTextBoxID);
    var objCheckbox = $('#' + strCheckBoxID);
    var objCheckboxSpan = $(objCheckbox.closest('span'));
    
    if (objCheckbox.length > 0) {
        if (objTextBox.val() != '') {            
            objCheckboxSpan.removeAttr('disabled');
            objCheckbox.removeAttr('disabled');
            if (blnCheckBoxChecked) {
                objCheckbox.attr('checked', true);
            }            
        }
        else {            
            objCheckboxSpan.attr('disabled', 'disabled');
            objCheckbox.attr('disabled', 'disabled');
            objCheckbox.attr('checked', false);            
       }
    }    
}

SD.DOM.EnableControlStartup = function (strTextBoxID, strCheckBoxID, blnCheckBoxChecked) {
    $(document).ready(function () {
        SD.DOM.EnableControl(strTextBoxID, strCheckBoxID, blnCheckBoxChecked);
    });
}

// **************************************************************************
// FUNCTION: GetElementOrParentWithAttribute
// USAGE:    
// **************************************************************************
SD.DOM.GetElementOrParentWithAttribute = function GetElementOrParentWithAttribute(objTarget, strAttribute) {

    // When the target has the attribute ...
    if (objTarget.is('[' + strAttribute + ']')) {

        // Return the target ... 
        return objTarget;

    } else {

        // Get the parent with the attribute ...
        var objParentWithAttribute = objTarget.closest('[' + strAttribute + ']');

        // When a parent with the attribute has been found ...
        if (objParentWithAttribute.length > 0) {

            // Return the parent with the attribute ...
            return objParentWithAttribute;
        }
    }

    // Not found ...
    return null;
}

// **************************************************************************
// FUNCTION: GetElementOrParentWithClass
// USAGE:    
// **************************************************************************
SD.DOM.GetElementOrParentWithClass = function GetElementOrParentWithClass(objTarget, strClass) {

    // When the target has the class ...
    if (objTarget.is('.' + strClass)) {

        // Return the target ... 
        return objTarget;

    } else {

        // Get the parent with the class ...
        var objParentWithClass = objTarget.closest('.' + strClass);

        // When a parent with the class has been found ...
        if (objParentWithClass.length > 0) {

            // Return the parent with the class ...
            return objParentWithClass;
        }
    }

    // Not found ...
    return null;
}

// **************************************************************************
// FUNCTION: GetElementOrParentWithSelector
// USAGE:    
// **************************************************************************
SD.DOM.GetElementOrParentWithSelector = function GetElementOrParentWithSelector(objTarget, strSelector) {

    // When the target has the class ...
    if (objTarget.is(strSelector)) {

        // Return the target ... 
        return objTarget;

    } else {

        // Get the parent with the selector ...
        var objParentWithSelector = objTarget.closest(strSelector);

        // When a parent with the selector were found ...
        if (objParentWithSelector.length > 0) {

            // Return the parent with the selector ...
            return objParentWithSelector;
        }
    }

    // Not found ...
    return null;
}

// **************************************************************************
// FUNCTION: MaxZIndex
// USAGE:    
// **************************************************************************
SD.DOM.MaxZIndex = function MaxZIndex() {

    // Get all the elements on the page ...
    var objElements = $('*');

    // Start with a max z-index of 0 ..
    var intMaxZIndex = 0;

    // Get all the DOM elemnts as an array ...
    var arrDomElements = objElements.toArray();

    // Loop through all the elements ...
    $.each(arrDomElements, function (intDOMElement, objDOMElement) {
                 
        // Get the z-index of the element ...
        var intZIndex = parseFloat($(objDOMElement).css('z-index'));

        if (SD.DOM.ElementIDsToExclude != null) {
            if (SD.DOM.ElementIDsToExclude.indexOf(objDOMElement.id) >= 0) {
                intZIndex = null;
            }
        }
        // Set as the max when valid and larger than the max ...
        if ((typeof intZIndex != 'undefined') && (intZIndex != null) && (!isNaN(intZIndex)) && (intZIndex > intMaxZIndex)) { intMaxZIndex = intZIndex; }
    });

    // Return the maximum index ...
    return intMaxZIndex;
}

// **************************************************************************
// FUNCTION: BringToFront
// USAGE:    
// **************************************************************************
SD.DOM.BringToFront = function BringToFront(objElement) {

    // Get the current max z-index ...
    var intMaxZIndex = SD.DOM.MaxZIndex();

    // Loop though all the DOM elements ...
    objElement.each(function () {

        // Increment the z-Index ...
        intMaxZIndex++;

        // Set the z-Index of the DOM element ...
        $(this).css('z-index', intMaxZIndex);
    });
}

// **************************************************************************
// FUNCTION: RedirectToURL
// USAGE:    
// **************************************************************************
SD.DOM.RedirectToUrl = function RedirectToUrl(strUrl)
{
    window.location.href = strUrl;
}




function URLToFullPath(objPage, strPage) {

    var strPathName;
    var strReturn;

    // get the path name from the page location pathname function, this will return /localhost/page.aspx
    strPathName = objPage.location.pathname;

    //Trim the first '/' from the path
    strPathName = strPathName.substring(1, strPathName.length);

    // trim off the 'page.aspx' from the string
    strPathName = strPathName.substring(0, strPathName.indexOf("/") + 1);

    //build up the return string
    strReturn = "/" + strPathName + strPage

    return strReturn;

};


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var SD = SD || {};
SD.Guid = SD.Guid || { Shared: {} };

// **************************************************************************
// FUNCTION: NewID
// USAGE:    Creates a new random guid ...
// **************************************************************************
SD.Guid.Shared.NewID = function NewID() {

    var strGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (objChar) {
        var intRandomBase16 = Math.random() * 16 | 0;
        var intValueBase16 = (objChar == 'x') ? intRandomBase16 : (intRandomBase16 & 0x3 | 0x8);
        return intValueBase16.toString(16);
    });

    return strGuid;
}

// **************************************************************************
// FUNCTION: Empty
// USAGE:    Creates a new random guid ...
// **************************************************************************
SD.Guid.Shared.Empty = function Empty() {

    // Return a null guid string ....
    return '00000000-0000-0000-0000-000000000000';
}

// **************************************************************************
// FUNCTION: DefaultUserID
// USAGE:    Creates a new random guid ...
// **************************************************************************
SD.Guid.Shared.DefaultUserID = function DefaultUserID() {

    return 'AAAAAAAA-AAAA-AAAA-AAAA-AAAAAAAAAAAA';
}

// **************************************************************************
// FUNCTION: IsGuid
// USAGE:    Checks if the gibven value is a Guid
// **************************************************************************
SD.Guid.Shared.IsGuid = function IsGuid(strValue) {
    let regex = /[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}/i;
    let match = regex.exec(strValue);

    return match != null;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
SD.HtmlFunctions = SD.HtmlFunctions || { Shared : { } };

// Global variables ...
SD.HtmlFunctions.Shared.IE9FilterFromGradientRemoved = false;

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION PreventIOSElasticity
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.HtmlFunctions.Shared.PreventIOSElasticity = function PreventIOSElasticity() {

    // Attach to the touchmove event ...
    $(document).on('touchmove', function (e) {

        // Prevent the default behavior (iOS elasticity) ...
        e.preventDefault();
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RemoveIE9FilterFromGradient
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.HtmlFunctions.Shared.RemoveIE9FilterFromGradient = function RemoveIE9FilterFromGradient() {

    // Attach an event handler to be fired when the document is ready ...
    $(document).ready(function () {

        // When not removed yet ...
        if (!SD.HtmlFunctions.Shared.IE9FilterFromGradientRemoved) {

            // Add the gradient style for IE 9 only ...
            $('body').append('<!--[if gte IE 9]><style type="text/css">.gradient {filter: none;}</style><![endif]-->');

            // Set to be removed ...
            SD.HtmlFunctions.Shared.IE9FilterFromGradientRemoved = true;
        }
    });
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION MeasureElement
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.HtmlFunctions.Shared.MeasureElement = function MeasureElement(objElement) {

    // Create the size object to return ...
    var objSize = { width: 0, height: 0 };

    // When we have an element ...
    if ((typeof objElement != 'undefined') && (objElement != null)) {

        // Clone the element ...
        var objClonedElement = objElement.clone();

        // Hide the element ...
        objClonedElement.hide();    

        // Set the positioning to be absolute ...
        objClonedElement.css('position', 'absolute');

        // Add to the parent ... 
        objElement.parent().append(objClonedElement);

        // Set the size ...
        objSize.width = parseInt(objClonedElement.outerWidth(), 10);
        objSize.height = parseInt(objClonedElement.outerHeight(), 10);

        // remove cloned element
        objClonedElement.remove();
    }

    return objSize;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ResizeModalElement
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.HtmlFunctions.Shared.ResizeModalElement = function (objElementToScroll, intVerticalPadding) {

    var decWindowHeight = $(window).height();
    var decElementHeight = (decWindowHeight * .95) - intVerticalPadding; //95% is the height of the modalDialog Host

    objElementToScroll.css('max-height', decElementHeight + 'px');
    objElementToScroll.css('ms-max-height', decElementHeight + 'px');

    var decScrollHeight = objElementToScroll.prop("scrollHeight");
    var decClientHeight = objElementToScroll.prop("clientHeight");

    if (decScrollHeight > decClientHeight) {
        objElementToScroll.css('overflow-y', 'scroll');
    } else {
        objElementToScroll.css('overflow-y', 'auto');
    }
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION Highlight contents of an element
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
function selectText(element) {

    if (document.selection) {
        var range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
    } else if (window.getSelection) {
        var range = document.createRange();
        range.selectNodeContents(element);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
    }
};


// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION Copies text from an input element to the clipboard.
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
function copyText(element) {

    selectText(element);
    document.execCommand("copy");

};


// Create the SD namespace object (if it does not exist already) ...
var SD = SD || {};

// Create the LoadDisplayValue object ...
SD.LoadDisplayValue = SD.LoadDisplayValue || {};


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var SD = SD || {};
SD.ModeButtons = SD.ModeButtons || { Shared: {} };

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
SD.ModeButtons.CreateInstance = function CreateInstance(strUniqueIDPrefix, strDefaultActiveButtonName) {

    // Create the object that will hold the instance properties ...
    var objModeButtons = {
        ContainerElement: null,
        UniqueIDPrefix: strUniqueIDPrefix,
        DefaultActiveButtonName: strDefaultActiveButtonName,
        Buttons: [],
        ButtonDivs: {},
        ButtonContainerDiv: null,
        IsInitialized: false,
        ActiveButton: null,
        ActiveButtonDiv: null,
        AllowModeChange: true,
        CannotChangeModeTitle: null,
        CannotChangeModeMessage: null,

        ModeButtonsClickedProxy: function (e) { objModeButtons.ModeButtonsClicked(e) },

        Init: SD.ModeButtons.Init,
        CreateElements: SD.ModeButtons.CreateElements,
        CreateButtonElements: SD.ModeButtons.CreateButtonElements,
        CreateAndAddButtonElement: SD.ModeButtons.CreateAndAddButtonElement,
        AddButton: SD.ModeButtons.AddButton,
        RemoveButton: SD.ModeButtons.RemoveButton,
        SortButtons: SD.ModeButtons.SortButtons,
        GetButtonByName: SD.ModeButtons.GetButtonByName,
        GetButtonIndex: SD.ModeButtons.GetButtonIndex,
        ModeButtonsClicked: SD.ModeButtons.ModeButtonsClicked,
        ActivateButton: SD.ModeButtons.ActivateButton,
        DisableModeChange: SD.ModeButtons.DisableModeChange,
        EnableModeChange: SD.ModeButtons.EnableModeChange,
        UpdateVisiblity: SD.ModeButtons.UpdateVisiblity,
        Show: SD.ModeButtons.Show,
        Hide: SD.ModeButtons.Hide,
        ActivateDefaultButton: SD.ModeButtons.ActivateDefaultButton
    };

    return objModeButtons;
}

// **************************************************************************
// FUNCTION: Init
// USAGE:    
// **************************************************************************
SD.ModeButtons.Init = function Init(objContainerElement) {

    // Get the instance ...
    var objModeButtons = this;

    // Set the container element ...
    objModeButtons.ContainerElement = objContainerElement;

    // Create the dom elements ...
    objModeButtons.CreateElements();

    // Set to be initialized ...
    objModeButtons.IsInitialized = true;

    // Attach the click event handler ...
    objModeButtons.ButtonContainerDiv.on('click', (objModeButtons.ModeButtonsClickedProxy));

    // Activate the default button ...
    objModeButtons.ActivateDefaultButton();

    // Update the visibilty of the control ...
    objModeButtons.UpdateVisiblity();
}

// **************************************************************************
// FUNCTION: ActivateDefaultButton
// USAGE:    
// **************************************************************************
SD.ModeButtons.ActivateDefaultButton = function ActivateDefaultButton() {

    // Get the instance ...
    var objModeButtons = this;

    // When we have a default active button ...
    if (objModeButtons.DefaultActiveButtonName) {

        // Activate the button ...
        objModeButtons.ActivateButton(objModeButtons.GetButtonByName(objModeButtons.DefaultActiveButtonName));
    }
}

// **************************************************************************
// FUNCTION: UpdateVisiblity
// USAGE:    
// **************************************************************************
SD.ModeButtons.UpdateVisiblity = function UpdateVisiblity() {

    // Get the instance ...
    var objModeButtons = this;

    // When we have any mode buttons ...
    if (objModeButtons.Buttons.length > 0) {

        // Show the button container div ...
        objModeButtons.ButtonContainerDiv.show();

    } else {

        // Hide the button container div ...
        objModeButtons.ButtonContainerDiv.hide();
    }
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    
// **************************************************************************
SD.ModeButtons.Show = function Show() {

    // Get the instance ...
    var objModeButtons = this;

    // When we have any mode buttons ...
    if (objModeButtons.Buttons.length > 0) {

        // Activate the default button ...
        objModeButtons.ActivateDefaultButton();

        // Show the button container div ...
        objModeButtons.ButtonContainerDiv.show();
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    
// **************************************************************************
SD.ModeButtons.Hide = function Hide() {

    // Get the instance ...
    var objModeButtons = this;

    if (objModeButtons.ActiveButton) {

        // Deactivate the activate button ...
        objModeButtons.ActiveButton.DeActivate(objModeButtons.ActiveButton);

        // Set to have no active button ...
        objModeButtons.ActiveButton = null;
        // Remove the active button class ...
        objModeButtons.ActiveButtonDiv.removeClass('selected-mode');
    }

    // Hide the button container div ...
    objModeButtons.ButtonContainerDiv.hide();
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
SD.ModeButtons.CreateElements = function CreateElements() {

    // Get the instance ...
    var objModeButtons = this;

    // Create the button container div ...
    objModeButtons.ButtonContainerDiv = $('<div id ="' + objModeButtons.UniqueIDPrefix + '_ModeButtons" class="mode-buttons"></div>');

    // Create and add the button elements ...
    objModeButtons.CreateButtonElements();

    // Append it to the container element ...
    objModeButtons.ContainerElement.append(objModeButtons.ButtonContainerDiv);
}

// **************************************************************************
// FUNCTION: SortButtons
// USAGE:    
// **************************************************************************
SD.ModeButtons.SortButtons = function SortButtons() {

    // Get the instance ...
    var objModeButtons = this;

    // Sort the buttons according to their order ...
    objModeButtons.Buttons = objModeButtons.Buttons.sort(function (objModeButtonA, objModeButtonB) { return objModeButtonA.Order - objModeButtonB.Order; });
}

// **************************************************************************
// FUNCTION: CreateButtonElements
// USAGE:    
// **************************************************************************
SD.ModeButtons.CreateButtonElements = function CreateButtonElements() {

    // Get the instance ...
    var objModeButtons = this;

    // Sort the buttons according to order ...
    objModeButtons.SortButtons();

    // Loop through all the buttons ...
    for (var intButton = 0; intButton < objModeButtons.Buttons.length; intButton++) {

        // Get the button instance ...
        var objModeButton = objModeButtons.Buttons[intButton];

        // Create and add the button element ...
        objModeButtons.CreateAndAddButtonElement(objModeButton);
    }
}

// **************************************************************************
// FUNCTION: CreateAndAddButtonElement
// USAGE:    
// **************************************************************************
SD.ModeButtons.CreateAndAddButtonElement = function CreateAndAddButtonElement(objModeButton, objInsertAfterButtonDiv, blnPrepend) {

    // Get the instance ...
    var objModeButtons = this;

    // Default prepend to false when not set ...
    if (typeof blnPrepend == 'undefined') { blnPrepend = false; }

    // Create the button div ...
    var objButtonDiv = $('<div class="mode-button" ButtonName="' + objModeButton.Name + '" title="' + objModeButton.Tooltip + '"></div>');

    // Add the css class ...
    objButtonDiv.addClass(objModeButton.CssClass);

    // When we have a button div after which should insert the button ...
    if ((typeof objInsertAfterButtonDiv != 'undefined') && (objInsertAfterButtonDiv)) {

        // Add it to the container element ... 
        objInsertAfterButtonDiv.after(objButtonDiv);

    } else {

        // When we are to prepend ...
        if (blnPrepend) {

            // Add it to the beginning of the container element ... 
            objModeButtons.ButtonContainerDiv.prepend(objButtonDiv);

        } else {

            // Add it to the end of the container element ... 
            objModeButtons.ButtonContainerDiv.append(objButtonDiv);
        }
    }

    // Add it to the list of button divs ...
    objModeButtons.ButtonDivs[objModeButton.Name] = objButtonDiv;
}

// **************************************************************************
// FUNCTION: AddButton
// USAGE:    
// **************************************************************************
SD.ModeButtons.AddButton = function AddButton(objModeButton) {

    // Get the instance ...
    var objModeButtons = this;

    // Add the button to the list ...
    objModeButtons.Buttons.push(objModeButton);

    // When the control has already been initialized ...
    if (objModeButtons.IsInitialized) {

        // Decalre a variable for the button div to insert after ... 
        var objInsertAfterButtonDiv;

        // When we now have more than one button ...
        if (objModeButtons.Buttons.length > 1) {

            // Sort the mode buttons ...
            objModeButtons.SortButtons();

            // Declare a variable for the button to insert after ...
            var intButtonIndex = $.inArray(objModeButton, objModeButtons.Buttons);

            // Get the div of the previous button when not the first button ...
            if (intButtonIndex > 0) { objInsertAfterButtonDiv = objModeButtons.ButtonDivs[objModeButtons.Buttons[intButtonIndex - 1].Name]; }
        }

        // Create and add the button element ...
        objModeButtons.CreateAndAddButtonElement(objModeButton, objInsertAfterButtonDiv, true);

        // Update the visibilty of the control ...
        objModeButtons.UpdateVisiblity();
    }
}

// **************************************************************************
// FUNCTION: RemoveButton
// USAGE:    
// **************************************************************************
SD.ModeButtons.RemoveButton = function RemoveButton(objModeButton) {

    // Get the instance ...
    var objModeButtons = this;

    // When this mode buttons control has already been initialized ...
    if (objModeButtons.IsInitialized) {

        // Get the button div ...
        var objButtonDiv = objModeButtons.ButtonDivs[objModeButton.Name];

        // When found ...
        if (objButtonDiv) {

            // When we are removing the active button ...
            if (objModeButtons.ActiveButton == objModeButton) {

                // Get the default active button ...
                var objButtonToActivate = objModeButtons.GetButtonByName(objModeButtons.DefaultActiveButtonName);

                // Set to not activate the default button when its teh button that we are busy removing ...
                if (objButtonToActivate == objModeButton) { objButtonToActivate = null; }

                // When we do not have a default active button to activate ...
                if (!objButtonToActivate) {

                    // Loop through all the buttons ...
                    $.each(objModeButtons.Buttons, function (intTestButton, objTestButton) {

                        // When not the mode button to remove ...
                        if (objTestButton != objModeButton) { objButtonToActivate = objModeButton; return false; }
                    });
                }

                // When we have a button to activate ...
                if (objButtonToActivate) {

                    // Activate the button ...
                    objModeButtons.ActivateButton(objButtonToActivate);

                } else {

                    // Deactivate the activate button ...
                    objModeButtons.ActiveButton.DeActivate(objModeButtons.ActiveButton);

                    // Set to have no active button ...
                    objModeButtons.ActiveButton = null;
                }
            }

            // Remove the button from the DOM ...
            objButtonDiv.remove();

            // Remove it from the button divs hash table ...
            delete objModeButtons.ButtonDivs[objModeButton.Name];
        }

        // Get the button index ...
        var intButton = objModeButtons.GetButtonIndex(objModeButton.Name);

        // Remove the button from the buttons array ...
        if (intButton > -1) { objModeButtons.Buttons.splice(intButton, 1); }

        // Update the visibilty of the control ...
        objModeButtons.UpdateVisiblity();

    } else {

        // Get the button index ...
        var intButton = objModeButtons.GetButtonIndex(objModeButton.Name);

        // Remove the button from the buttons array ...
        if (intButton > -1) { objModeButtons.Buttons.splice(intButton, 1); }
    }
}

// **************************************************************************
// FUNCTION: GetButtonIndex
// USAGE:    
// **************************************************************************
SD.ModeButtons.GetButtonIndex = function GetButtonIndex(strButtonName) {

    // Get the instance ...
    var objModeButtons = this;

    // Loop through all the buttons ...
    for (var intButton = 0; intButton < objModeButtons.Buttons.length; intButton++) {

        // Get the button ...
        var objButton = objModeButtons.Buttons[intButton];

        // When the buton name matches ...
        if (objButton.Name == strButtonName) {

            // Return the index ...
            return intButton;
        }
    }

    // Not found ...
    return -1;
}

// **************************************************************************
// FUNCTION: GetButtonByName
// USAGE:    
// **************************************************************************
SD.ModeButtons.GetButtonByName = function GetButtonByName(strButtonName) {

    // Get the instance ...
    var objModeButtons = this;

    // Start with not found ...
    var objButton = null;

    // Loop through all the buttons ...
    $.each(objModeButtons.Buttons, function (intTestButton, objTestButton) {

        // When the button name matches, set to return the button ...
        if (objTestButton.Name == strButtonName) { objButton = objTestButton; }
    });

    return objButton;
}

// **************************************************************************
// FUNCTION: ModeButtonsClicked
// USAGE:    
// **************************************************************************
SD.ModeButtons.ModeButtonsClicked = function ModeButtonsClicked(e) {

    // Get the instance ...
    var objModeButtons = this;

    // Get the target of the click event ...
    var objTarget = $(e.target);

    // When a mode button ...
    if (objTarget.hasClass('mode-button')) {

        // Get the button name attribute ...
        var strButtonName = objTarget.attr('ButtonName');

        // Get the mode button by name ...
        var objButtonToActivate = objModeButtons.GetButtonByName(strButtonName);

        // Activate the button ...
        objModeButtons.ActivateButton(objButtonToActivate);
    }
}

// **************************************************************************
// FUNCTION: ActivateButton
// USAGE:    
// **************************************************************************
SD.ModeButtons.ActivateButton = function ActivateButton(objButtonToActivate) {

    // Get the instance ...
    var objModeButtons = this;

    // When we have a button to activate and it is not already active ...
    if ((objButtonToActivate != null) && (objModeButtons.ActiveButton != objButtonToActivate)) {

        // When a mode change is to be allowed ...
        if (objModeButtons.AllowModeChange) {

            // When we have an active button ...
            if (objModeButtons.ActiveButton) {

                // Call DeActivate callback ...
                objModeButtons.ActiveButton.DeActivate(objModeButtons.ActiveButton);

                // Remove the active button class ...
                objModeButtons.ActiveButtonDiv.removeClass('selected-mode');
            }

            // Get the button's div ...
            var objButtonDivToActivate = objModeButtons.ButtonDivs[objButtonToActivate.Name];

            // Set the button to activate to be the new active button ...
            objModeButtons.ActiveButton = objButtonToActivate;

            // Set the clicked div to be the active button div ...
            objModeButtons.ActiveButtonDiv = objButtonDivToActivate;

            // Add the selected class ...
            objButtonDivToActivate.addClass('selected-mode');

            // Call Activate callback ...
            objModeButtons.ActiveButton.Activate(objModeButtons.ActiveButton);

        } else {

            // Notify the user that the mode cannot be changed at this point ...
            TrimbleMap.MessageBox.Shared.ShowMessage(objModeButtons.CannotChangeModeTitle, objModeButtons.CannotChangeModeMessage, function () { });
        }
    }
}

// **************************************************************************
// FUNCTION: DisableModeChange
// USAGE:    
// **************************************************************************
SD.ModeButtons.DisableModeChange = function DisableModeChange(strCannotChangeModeTitle, strCannotChangeModeMessage) {

    // Get the instance ...
    var objModeButtons = this;

    // Set to not allow a mode change ...
    objModeButtons.AllowModeChange = false;

    // Set the title and message to display when the user attempts to change the mode ...
    objModeButtons.CannotChangeModeTitle = strCannotChangeModeTitle;
    objModeButtons.CannotChangeModeMessage = strCannotChangeModeMessage;
}

// **************************************************************************
// FUNCTION: EnableModeChange
// USAGE:    
// **************************************************************************
SD.ModeButtons.EnableModeChange = function EnableModeChange() {

    // Get the instance ...
    var objModeButtons = this;

    // Set to allow a mode change again ...
    objModeButtons.AllowModeChange = true;

    // Clear the title and message to display when the user attempts to change the mode ...
    objModeButtons.CannotChangeModeTitle = null;
    objModeButtons.CannotChangeModeMessage = null;

}

// **************************************************************************
// FUNCTION: CreateButton
// USAGE:    
// **************************************************************************
SD.ModeButtons.Shared.CreateButton = function CreateButton(strName, strCssClass, strTooltip, intOrder, fnActivate, fnDeActivate) {

    // Create and return a new button instance ...
    return {
        Name: strName,
        CssClass: strCssClass,
        Tooltip: strTooltip,
        Order: intOrder,
        Activate: fnActivate,
        DeActivate: fnDeActivate
    };
}
// Create the SD namespace object (if it does not exist already) ...
var SD = SD || {};

// Create the Number object ...
SD.Number = SD.Number || {};

SD.Number.NULL_NUMBER = -9999;

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RoundTo: Rounds a number to the specified number of decimal places ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.RoundTo = function RoundTo(dblValue, intDecimalPlaces) {

    // Compute the multiplier an divider ...
    var decMultiplierAndDivider = Math.pow(10, intDecimalPlaces);

    // Multiply, round and divide ...
    return Math.round(dblValue * decMultiplierAndDivider) / decMultiplierAndDivider;
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RoundTo: Rounds a number down to the specified number of decimal places ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.RoundDown = function RoundDown(dblValue, intDecimalPlaces) {
    var dblReturn = SD.Number.NULL_NUMBER;

    // Compute the multiplier an divider ...
    var dblMultiplierAndDivider = Math.pow(10, intDecimalPlaces);

    dblReturn = dblValue * dblMultiplierAndDivider;

    dblReturn = Math.floor(dblReturn);

    dblReturn = dblReturn / dblMultiplierAndDivider;

    return dblReturn;
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION RoundTo: Rounds a number up to the specified number of decimal places ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.RoundUp = function RoundUp(dblValue, intDecimalPlaces) {
    var dblReturn = SD.Number.NULL_NUMBER;
    var dblSmall = SD.Number.NULL_NUMBER;

    // Compute the multiplier an divider ...
    var dblMultiplierAndDivider = Math.pow(10, intDecimalPlaces);

    dblReturn = dblValue * dblMultiplierAndDivider;

    dblSmall = Math.floor(dblReturn);

    if (dblSmall < dblReturn) {
        dblReturn = dblSmall + 1
    }

    dblReturn = dblReturn / dblMultiplierAndDivider;

    return dblReturn;
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION EscapeCharacterForRegex: Validates that the number has got the specified number of decimal places ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.EscapeCharacterForRegex = function EscapeCharacterForRegex(strCharacter) {

    // When a reserved regex character ...
    if (['[', ']', '{', '}', '(', ')', '<', '>', '\\', '^', '$', '.', '|', '?', '*', '+', '-'].indexOf(strCharacter) != -1) {

        // Add escape characters to it ...
        strCharacter = '\\' + strCharacter;
    };

    return strCharacter;
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildNumberRegexValidationString: Validates that the number has got the specified number of decimal places ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.BuildRegexPartFromDecimalPoint = function BuildRegexPartFromDecimalPoint(strDecimalSeparator, blnValidateDecimalPlaces, intDecimalPlaces, blnAllowIncomplete) {

    // Declare a variable for the result ...
    var strFromDecimalPoint = '';

    // Add escape characters to the decimal separator when it is a regex reserved character ...
    strDecimalSeparator = this.EscapeCharacterForRegex(strDecimalSeparator);

    // When the number of decimal places should be validated ...
    if (blnValidateDecimalPlaces) {

        // When any digits after the decimal separator is to be allowed ...
        if (intDecimalPlaces > 0) {

            // When incomplete entries are to be allowed ...
            if (blnAllowIncomplete) {

                // Allow to either just be the decimal separator, OR the decimal separator 
                // followed by at least one up to the number of allowed digits ...
                strFromDecimalPoint = '((' + strDecimalSeparator + ')|((' + strDecimalSeparator + '\\d{1,' + intDecimalPlaces + '})?))';
            }
            else {

                // Allow the decimal separator followed by the number of allowed digits ...
                strFromDecimalPoint = '((' + strDecimalSeparator + '\\d{1,' + intDecimalPlaces + '})?)';
            }
        }
    }
    else {

        // When incomplete entries are to be allowed ...
        if (blnAllowIncomplete) {

            // Allow the decimal separator followed by 0 or more digits (notice the *) ...
            strFromDecimalPoint = '((' + strDecimalSeparator + '(\\d)*)?)';
        }
        else {

            // Allow the decimal separator followed by 1 or more digits (notice the +) ...
            strFromDecimalPoint = '((' + strDecimalSeparator + '(\\d)+)?)';
        }
    };

    return strFromDecimalPoint
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION BuildNumberRegexValidationString: Validates that the number has got the specified number of decimal places ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.BuildNumberRegexValidationString = function BuildNumberRegexValidationString(strGroupSeparator, strDecimalSeparator, blnValidateDecimalPlaces, intDecimalPlaces, blnAllowIncomplete) {

    // Declare a variable for the result ...
    var strRegex;

    // Add escape characters to the group separator when it is a dot (.) ...
    if (strGroupSeparator == '.') { strGroupSeparator = '\\' + strGroupSeparator; };

    // Build the regex part to validate the number from the decimal point onwards ...
    var strFromDecimalPoint = this.BuildRegexPartFromDecimalPoint(strDecimalSeparator, blnValidateDecimalPlaces, intDecimalPlaces, blnAllowIncomplete)

    // * Build a regex to check that the group and decimal separators are on 
    //   the right place and that there is the correct amount if decimal places ...

    // When incomplete entries are to be allowed ...
    if (blnAllowIncomplete) {

        // Allow for when the there is less than 3 digits after 
        // a group separator or no digits after a decimal point ...
        strRegex = '^(-?)(((\\d+)' + strFromDecimalPoint + ')|((\\d{1,3})((' + strGroupSeparator + '\\d{3})*)((' + strGroupSeparator + '\\d{0,2})|' + strFromDecimalPoint + ')))$';
    }
    else {

        // Do not allow for incomplete entries ...
        strRegex = '^(-?)(((\\d+)' + strFromDecimalPoint + ')|((\\d{1,3})((' + strGroupSeparator + '\\d{3})*)' + strFromDecimalPoint + '))$';
    };

    // Return the regular expression ...
    return strRegex;
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ValidateNumber: Validates that it as a valid number ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.ValidateIsNumber = function ValidateIsNumber(strFieldValue, strGroupSeparator, strDecimalSeparator, blnAllowInComplete) {

    // Construct a regular expression to test for a valid number ...
    var objRegExp = new RegExp(this.BuildNumberRegexValidationString(strGroupSeparator, strDecimalSeparator, false, 0, blnAllowInComplete));

    // When the valueis not a valid number ...
    if (!objRegExp.test(strFieldValue)) {

        return false;
    };

    // Valid then ...
    return true;
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ToNumber: Converts a string to a number value taking the 
//                    group and decimal separators into account ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.ToNumber = function ToNumber(strValue, strGroupSeparator, strDecimalSeparator) {

    var objGroupSeparatorRegEx = new RegExp(strGroupSeparator.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "g");
    var objDecimalSeparatorRegEx = new RegExp(strDecimalSeparator.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), "g");

    // Convert the string to a value ...
    return Number(strValue.replace(objGroupSeparatorRegEx, '').replace(objDecimalSeparatorRegEx, '.'));
};


// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION Round: Rounds given number based on the style and decimals
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.Round = function Round(dblAmount, strRoundingStyle, intRoundingDecimals) {

    if (strRoundingStyle === 'Nearest') {
        return SD.Number.RoundTo(dblAmount, intRoundingDecimals);
    }
    else if (strRoundingStyle === 'Up') {
        return SD.Number.RoundUp(dblAmount, intRoundingDecimals);
    }
    else if (strRoundingStyle === 'Down') {
        return SD.Number.RoundDown(dblAmount, intRoundingDecimals);
    }

    return NaN;
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ToString: Converts a number value to a string ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.ToString = function ToString(strValue, strDecimalSeparator) {

    // Convert the number to a string ...
    var strStringValue = String(strValue);

    // Replace the dots (.) with the decimal separator ...
    return strStringValue.replace('.', strDecimalSeparator);
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION Truncate: Truncates the decimal part of a number ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.Truncate = function Truncate(objValue) {

    // When the value is positive ...
    if (objValue > 0) {

        // Return the floor of the value ...
        return Math.floor(objValue);
    }
    else {

        // Return the ceiling of the value ...
        return Math.ceil(objValue);
    }
};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ZeroPadDecimal
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Number.ZeroPadDecimal = function ZeroPadDecimal(strValue, intDigitsBeforeDecimalPoint, intDigitsAfterDecimalPoint, strGroupSeparator, strDecimalSeparator) {

    // Convert the string to a number ...
    var decValue = SD.Number.ToNumber(strValue, strGroupSeparator, strDecimalSeparator);

    // Convert the number to a string with the number of decimal places ...
    var strPaddedValue = SD.DisplayValue.FromDouble(decValue, strGroupSeparator, strDecimalSeparator, intDigitsAfterDecimalPoint);

    // When we are to zero pad before the decimal ...
    if ((typeof intDigitsBeforeDecimalPoint != 'undefined') && (intDigitsBeforeDecimalPoint != null)) {

        // Zero pad the integer part ...
        strPaddedValue = SD.String.ZeroPad(strPaddedValue, intDigitsBeforeDecimalPoint + intDigitsAfterDecimalPoint + 1);
    }

    // Return the padded number ...
    return strPaddedValue;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the SD.Popup namespace ...
var SD = SD || {};
SD.Popup = SD.Popup || {
    Shared: {
        OPEN_POPUP_DELAY_MS: 100,
        CLOSE_POPUP_DELAY_MS: 300
    }
};

// **************************************************************************
// Enums ...
// **************************************************************************
SD.Popup.enumPopupBehaviour = {
    DownOrUpBasedOnSpaceAvailable: 'DownOrUpBasedOnSpaceAvailable',
    AlwaysUp: 'AlwaysUp',
    AlwaysDown: 'AlwaysDown'
};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
SD.Popup.CreateInstance = function CreateInstance(objActivationElement, strContainerToOpenDownwardsCssClassName, strContainerToOpenUpwardsCssClassName, strExtendedActivationElementToOpenDownwardsCssClassName, strExtendedActivationElementToOpenUpwardsCssClassName, intPopupDistance, blnAttachHandlers, enPopupBehaviour, fnActivatePopup, fnDeActivatePopup, fnPopupOpened) {

    // Create the object that will hold the instance properties ...
    var objPopup = {
        ActivationElement: objActivationElement,
        PopupDistance: intPopupDistance,
        PopupBehaviour: enPopupBehaviour,
        ActivatePopupFunction: fnActivatePopup,
        DeActivatePopupFunction: fnDeActivatePopup,
        PopupOpenedFunction: fnPopupOpened,
        Opened: false,
        OpenPopupTimer: null,
        ClosePopupTimer: null,
        PopupContainerDiv: null,
        ContainerToOpenDownwardsCssClassName: strContainerToOpenDownwardsCssClassName,
        ContainerToOpenUpwardsCssClassName: strContainerToOpenUpwardsCssClassName,
        PreventClose: false,
        CloseCallbacks: [],
        Enabled: true,

        MouseEnterHandlerProxy: function (e) { objPopup.MouseEnterHandler(e); },
        MouseLeaveHandlerProxy: function (e) { objPopup.MouseLeaveHandler(e); },
        ClickHandlerProxy: function (e) { objPopup.ClickHandler(e); },

        AttachEventHandlers: SD.Popup.AttachEventHandlers,
        DetachEventHandlers: SD.Popup.DetachEventHandlers,
        MouseEnterHandler: SD.Popup.MouseEnterHandler,
        MouseLeaveHandler: SD.Popup.MouseLeaveHandler,
        ClickHandler: SD.Popup.ClickHandler,
        OpenPopup: SD.Popup.OpenPopup,
        ClosePopup: SD.Popup.ClosePopup,
        StartClosePopupTimer: SD.Popup.StartClosePopupTimer,
        AddCloseCallback: SD.Popup.AddCloseCallback,
        CallCloseCallbacks: SD.Popup.CallCloseCallbacks,
        Enable: SD.Popup.Enable,
        Disable: SD.Popup.Disable
    };

    // When the event handlers is to be attached immediately ...
    if (blnAttachHandlers) { objPopup.AttachEventHandlers(); }

    return objPopup;
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
SD.Popup.AttachEventHandlers = function AttachEventHandlers() {

    // Get the instance ...
    var objPopup = this;

    // Attach the mouse enter event handler to the activation popup ...
    objPopup.ActivationElement.on('mouseenter',(objPopup.MouseEnterHandlerProxy));

    // Attach the mouse leave event handler to the activation popup ...
    objPopup.ActivationElement.on('mouseleave',(objPopup.MouseLeaveHandlerProxy));

    // Attach the click handler to the activation popup ...
    objPopup.ActivationElement.on('click',(objPopup.ClickHandlerProxy));
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
SD.Popup.DetachEventHandlers = function DetachEventHandlers() {

    // Get the instance ...
    var objPopup = this;

    // Detach the mouse enter event handler from the activation popup ...
    objPopup.ActivationElement.off('mouseenter', objPopup.MouseEnterHandlerProxy);

    // Attach the mouse leave event handler to the activation popup ...
    objPopup.ActivationElement.off('mouseleave', objPopup.MouseLeaveHandlerProxy);

    // Detach the click handler to the activation popup ...
    objPopup.ActivationElement.off('click', objPopup.ClickHandlerProxy);
}

// **************************************************************************
// FUNCTION: MouseEnterHandler
// USAGE:    
// **************************************************************************
SD.Popup.MouseEnterHandler = function MouseEnterHandler() {

    // Get the instance ...
    var objPopup = this;

    // When enabled ...
    if (objPopup.Enabled) {

        // When we have a close popup timer ...
        if (objPopup.ClosePopupTimer) {

            // Clear the close popup timer ...
            clearTimeout(objPopup.ClosePopupTimer);

            // Set to have no timer anymore ...
            objPopup.ClosePopupTimer = null;
        }

        // When not opened and we do not have a timer running yet ...
        if (!objPopup.Opened && (!objPopup.OpenPopupTimer)) {

            // Set a timer to open the popup after 100 ms ...
            objPopup.OpenPopupTimer = setTimeout(function () {

                // Open the Popup ...
                objPopup.OpenPopup();

            }, SD.Popup.Shared.OPEN_POPUP_DELAY_MS);
        }
    }
}

// **************************************************************************
// FUNCTION: MouseLeaveHandler
// USAGE:    
// **************************************************************************
SD.Popup.MouseLeaveHandler = function MouseLeaveHandler() {

    // Get the instance ...
    var objPopup = this;

    // When closing is not to be prevented ...
    if (!objPopup.PreventClose) {

        // When we have a open popup timer ...
        if (objPopup.OpenPopupTimer) {

            // Clear the open popup timer ...
            clearTimeout(objPopup.OpenPopupTimer);

            // Set to null ...
            objPopup.OpenPopupTimer = null;
        }

        // Start the close popup timer ...
        objPopup.StartClosePopupTimer();
    }
}

// **************************************************************************
// FUNCTION: StartClosePopupTimer
// USAGE:    
// **************************************************************************
SD.Popup.StartClosePopupTimer = function StartClosePopupTimer() {

    // Get the instance ...
    var objPopup = this;

    // When opened and we do not have a timer running yet ...
    if ((objPopup.Opened) && (!objPopup.ClosePopupTimer)) {

        // Set a timer to open the popup after 100 ms ...
        objPopup.ClosePopupTimer = setTimeout(function () {

            // Close the Popup ...
            objPopup.ClosePopup();

        }, SD.Popup.Shared.CLOSE_POPUP_DELAY_MS);
    }
}

// **************************************************************************
// FUNCTION: ClickHandler
// USAGE:    
// **************************************************************************
SD.Popup.ClickHandler = function ClickHandler(e) {

    // Prevent the event from bubbling up to the parent element ...
    e.stopPropagation();
}

// **************************************************************************
// FUNCTION: ClosePopup
// USAGE:    
// **************************************************************************
SD.Popup.ClosePopup = function ClosePopup() {

    // Get the instance ...
    var objPopup = this;

    // Set the close popup timer to null ...
    objPopup.ClosePopupTimer = null;

    // When the popup container is open ...
    if (objPopup.Opened) {

        // Call the close callbacks ...
        objPopup.CallCloseCallbacks();

        // Call the de-activate popup callback function ...
        if ((typeof objPopup.DeActivatePopupFunction != 'undefined') && (objPopup.DeActivatePopupFunction)) { objPopup.DeActivatePopupFunction(objPopup.PopupContainerDiv); };

        // Remove the popup container from the interface ...
        objPopup.PopupContainerDiv.remove();

        // Set it to be null ...
        objPopup.PopupContainerDiv = null;

        // Set to be not opened ...
        objPopup.Opened = false;
    }
}

// **************************************************************************
// FUNCTION: CallCloseCallbacks
// USAGE:    
// **************************************************************************
SD.Popup.CallCloseCallbacks = function CallCloseCallbacks() {

    // Get the instance ...
    var objPopup = this;

    // Loop through all the close callbacks ...
    for (var intCloseCallback = 0; intCloseCallback < objPopup.CloseCallbacks.length; intCloseCallback++) {

        // Get the close callback ...
        var fnCloseCallback = objPopup.CloseCallbacks[intCloseCallback];

        // Call the close callback ...
        fnCloseCallback();
    }
}

// **************************************************************************
// FUNCTION: OpenPopup
// USAGE:    
// **************************************************************************
SD.Popup.OpenPopup = function OpenPopup() {

    // Get the instance ...
    var objPopup = this;

    // Set to have no timer anymore ...
    objPopup.OpenPopupTimer = null;

    // When not opened ...
    if (!objPopup.Opened) {

        // Create a div for the popup container ...
        objPopup.PopupContainerDiv = $('<div class="' + objPopup.ContainerToOpenDownwardsCssClassName + '"></div>');

        // Set the minimum width of the popup container to be the width of the activation element ...
        objPopup.PopupContainerDiv.css('min-width', (parseInt(objPopup.ActivationElement.outerWidth()) - 2) + 'px');

        // Call the activate popup callback function ...
        if ((typeof objPopup.ActivatePopupFunction != 'undefined') && (objPopup.ActivatePopupFunction)) { objPopup.ActivatePopupFunction(objPopup.PopupContainerDiv); };

        // Set the activation element to be relatively positioned ...
        objPopup.ActivationElement.css('position', 'relative');

        // Get the border width of the activation element ...
        var intBorderWidth = parseInt(objPopup.ActivationElement.css('border-inline-start-width'));

        // Get the position of the activation element relative to the document ...
        var objActivationElementOffset = objPopup.ActivationElement.offset();

        // Measure the activation element size ...
        var objActivationElementSize = SD.HtmlFunctions.Shared.MeasureElement(objPopup.ActivationElement);

        // Get the window height ...
        var intWindowHeight = $(window).height();

        // Measure the popup container element size ...
        var objPopupContainerSize = SD.HtmlFunctions.Shared.MeasureElement(objPopup.PopupContainerDiv);

        // Determine whether or not there is not enough space to open downwards ...
        var blnEnoughSpaceToOpenDownwards = (objActivationElementOffset.top + objActivationElementSize.height + objPopupContainerSize.height) < intWindowHeight;

        // Determine whether or not there is not enough space to open upwards ...
        var blnEnoughSpaceToOpenUpwards = (objActivationElementOffset.top - objPopupContainerSize.height) > 0;

        // Declare a variable ...
        var blnOpenDownwards = true;

        // Determine whether to open downwards or upwards based on the popup behaviour ...
        switch (objPopup.PopupBehaviour) {
            case SD.Popup.enumPopupBehaviour.DownOrUpBasedOnSpaceAvailable:
                blnOpenDownwards = blnEnoughSpaceToOpenDownwards || (!blnEnoughSpaceToOpenUpwards);
                break;
            case SD.Popup.enumPopupBehaviour.AlwaysDown:
                blnOpenDownwards = true;
                break;
            case SD.Popup.enumPopupBehaviour.AlwaysUp:
                blnOpenDownwards = false;
                break;
        }

        // Set the div to be absolutely positioned ...
        objPopup.PopupContainerDiv.css('position', 'absolute');

        let intBlockStart = 0;
        let intInlineStart = 0;

        // When we are to open downwards ...
        if (blnOpenDownwards) {

            // Position the popup below the activation element ...
            intInlineStart = parseInt(objPopup.ActivationElement.innerWidth()) - objPopupContainerSize.width + intBorderWidth;
            intBlockStart = parseInt(objPopup.ActivationElement.innerHeight());

            objPopup.PopupContainerDiv.css('inset-inline-start', intInlineStart + 'px');
            objPopup.PopupContainerDiv.css('inset-block-start', intBlockStart + 'px');

        } else {

            // Position the popup above the activation element ...
            intInlineStart = parseInt(objPopup.ActivationElement.innerWidth()) - objPopupContainerSize.width + intBorderWidth;
            intBlockStart = -objPopupContainerSize.height;

            objPopup.PopupContainerDiv.css('inset-inline-start', intInlineStart + 'px');
            objPopup.PopupContainerDiv.css('inset-block-start', intBlockStart + 'px');

            // Remove the "open downwards" css class name to the popup container div ...
            objPopup.PopupContainerDiv.removeClass(objPopup.ContainerToOpenDownwardsCssClassName);

            // Add the "open upwards" css class to the popup container div ...
            objPopup.PopupContainerDiv.addClass(objPopup.ContainerToOpenUpwardsCssClassName);
        }

        // Place the popup container div to the activation element ...
        objPopup.ActivationElement.append(objPopup.PopupContainerDiv);

        // Set to be opened ...
        objPopup.Opened = true;

        // Call the popup opened callback function ...
        if ((typeof objPopup.PopupOpenedFunction != 'undefined') && (objPopup.PopupOpenedFunction)) { objPopup.PopupOpenedFunction(objPopup.PopupContainerDiv); };
    }
}

// **************************************************************************
// FUNCTION: AddCloseCallback
// USAGE:    
// **************************************************************************
SD.Popup.AddCloseCallback = function AddCloseCallback(fnCallback) {

    // Get the instance ...
    var objPopup = this;

    // Add it to the list of close callbacks ...
    objPopup.CloseCallbacks.push(fnCallback);
}

// **************************************************************************
// FUNCTION: Enable
// USAGE:    
// **************************************************************************
SD.Popup.Enable = function Enable() {

    // Get the instance ...
    var objPopup = this;

    // Set to be enabled ...
    objPopup.Enabled = true;
}

// **************************************************************************
// FUNCTION: Disable
// USAGE:    
// **************************************************************************
SD.Popup.Disable = function Disable() {

    // Get the instance ...
    var objPopup = this;

    // Set to be disabled ...
    objPopup.Enabled = false;
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the SD.Popup namespace ...
var SD = SD || {};
SD.PopupMenu = SD.PopupMenu || { Shared: {} };

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
SD.PopupMenu.CreateInstance = function CreateInstance(objActivationElement, strContainerToOpenDownwardsCssClassName, strContainerToOpenUpwardsCssClassName, strExtendedActivationElementToOpenDownwardsCssClassName, strExtendedActivationElementToOpenUpwardsCssClassName, intPopupDistance, blnAttachHandlers, enPopupBehaviour, fnMenuItemClicked) {

    // Create the object that will hold the instance properties ...
    var objPopupMenu = {
        ActivationElement: objActivationElement,
        ExtendedActivationElement: null,
        PopupDistance: intPopupDistance,
        PopupBehaviour: enPopupBehaviour,
        MenuItemClickedFunction: fnMenuItemClicked,
        Popup: null,
        PopupDiv: null,
        MenuItems: [],

        ActivatePopupProxy: function (objPopupContainerDiv) { objPopupMenu.ActivatePopup(objPopupContainerDiv); },
        DeActivatePopupProxy: function (objPopupContainerDiv) { objPopupMenu.DeActivatePopup(objPopupContainerDiv); },
        ClickHandlerProxy: function (e) { objPopupMenu.ClickHandler(e); },

        AttachEventHandlers: SD.PopupMenu.AttachEventHandlers,
        DetachEventHandlers: SD.PopupMenu.DetachEventHandlers,
        ActivatePopup: SD.PopupMenu.ActivatePopup,
        DeActivatePopup: SD.PopupMenu.DeActivatePopup,
        AddMenuItem: SD.PopupMenu.AddMenuItem,
        ReplaceMenuItem: SD.PopupMenu.ReplaceMenuItem,
        RemoveMenuItem: SD.PopupMenu.RemoveMenuItem,
        SetMenuItems: SD.PopupMenu.SetMenuItems,
        ClickHandler: SD.PopupMenu.ClickHandler,
        GetMenuItemByID: SD.PopupMenu.GetMenuItemByID,
        EnableMenuItem: SD.PopupMenu.EnableMenuItem,
        EnableMenuItemChecked: SD.PopupMenu.EnableMenuItemChecked,
        CreateCheckMenuItem: SD.PopupMenu.CreateCheckMenuItem
    };

    // Create the popup ...
    objPopupMenu.Popup = SD.Popup.CreateInstance(objActivationElement,
        strContainerToOpenDownwardsCssClassName,
        strContainerToOpenUpwardsCssClassName,
        strExtendedActivationElementToOpenDownwardsCssClassName,
        strExtendedActivationElementToOpenUpwardsCssClassName,
        intPopupDistance,
        blnAttachHandlers,
        enPopupBehaviour,
        objPopupMenu.ActivatePopupProxy,
        objPopupMenu.DeActivatePopupProxy);

    // Hide the activation element for now (it will be displayed when we add menu items) ...
    objActivationElement.hide();

    return objPopupMenu;
}

// **************************************************************************
// FUNCTION: AttachEventHandlers
// USAGE:    
// **************************************************************************
SD.PopupMenu.AttachEventHandlers = function AttachEventHandlers() {

    // Get the instance ...
    var objPopupMenu = this;

    // Attach the popup's event handlers ...
    objPopupMenu.Popup.AttachEventHandlers();
}

// **************************************************************************
// FUNCTION: DetachEventHandlers
// USAGE:    
// **************************************************************************
SD.PopupMenu.DetachEventHandlers = function DetachEventHandlers() {

    // Get the instance ...
    var objPopupMenu = this;

    // Detach the popup's event handlers ...
    objPopupMenu.Popup.DetachEventHandlers();
}

// **************************************************************************
// FUNCTION: ActivatePopup
// USAGE:    
// **************************************************************************
SD.PopupMenu.ActivatePopup = function ActivatePopup(objPopupContainerDiv) {

    // Get the instance ...
    var objPopupMenu = this;

    // Create the popup div ...
    objPopupMenu.PopupDiv = $('<div class="popup-menu"></div>');

    // Add it to the popup container div ...
    objPopupContainerDiv.append(objPopupMenu.PopupDiv);

    // Loop through all the menu items ...
    for (var intMenu = 0; intMenu < objPopupMenu.MenuItems.length; intMenu++) {

        // Get the menu item ...
        var objMenuItem = objPopupMenu.MenuItems[intMenu];

        // Create a div for the operation item ...
        var objMenuItemDiv = $('<div></div>');

        var objCheckDiv = "";

        if (objMenuItem.GroupSeparator) {
            objMenuItemDiv.append("<hr></hr>");
        } else {

            // Add the ID for the menu item
            objMenuItemDiv.attr("MenuItemID", objMenuItem.ItemID);

            if (objMenuItem.Checked) {

                objCheckDiv = '<div class="checkbox"></div>';
            } else {
                objCheckDiv = '<div class="checkbox-placeholder"></div>';
            }

            // Create a div for the item text ...
            var objItemTextDiv = $(objCheckDiv + '<div><span>' + objMenuItem.ItemDescription + '</span></div>');

            objMenuItemDiv.addClass("popup-menu-item");

            if (objMenuItem.ReadOnly) {
                objItemTextDiv.find("span").addClass("readonly");
                objItemTextDiv.attr("title", objMenuItem.ToolTipWhenReadOnly);
            }

            // Add the checkbox and item text ...
            objMenuItemDiv.append(objItemTextDiv);
        }

        // Add the item div to the popup div ...
        objPopupMenu.PopupDiv.append(objMenuItemDiv);
    }

    // Attach the click event handler proxy ...
    objPopupMenu.PopupDiv.on('click',(objPopupMenu.ClickHandlerProxy));
}

// **************************************************************************
// FUNCTION: DeActivatePopup
// USAGE:    
// **************************************************************************
SD.PopupMenu.DeActivatePopup = function DeActivatePopup(objPopupContainerDiv) {

    // Get the instance ...
    var objPopupMenu = this;

    // Detach the click event handler proxy ...
    objPopupMenu.PopupDiv.off('click', objPopupMenu.ClickHandlerProxy);
}

// **************************************************************************
// FUNCTION: AddMenuItem
// USAGE:    
// **************************************************************************
SD.PopupMenu.AddMenuItem = function AddMenuItem(objMenuItem) {

    // Get the instance ...
    var objPopupMenu = this;

    // Create and add the menu item object ...
    objPopupMenu.MenuItems.push(objMenuItem);

    // Show the activation element ...
    objPopupMenu.ActivationElement.show();
}

// **************************************************************************
// FUNCTION: ReplaceMenuItem
// USAGE:    
// **************************************************************************
SD.PopupMenu.ReplaceMenuItem = function ReplaceMenuItem(index, objMenuItem) {

    // Get the instance ...
    var objPopupMenu = this;

    // Replace the menu item object ...
    objPopupMenu.MenuItems.splice(index, 1, objMenuItem);

    // Show the activation element ...
    objPopupMenu.ActivationElement.show();
}

// **************************************************************************
// FUNCTION: RemoveMenuItem
// USAGE:    
// **************************************************************************
SD.PopupMenu.RemoveMenuItem = function RemoveMenuItem(objMenuItem) {

    // Get the instance ...
    var objPopupMenu = this;

    // Find the index of the item in the array ...
    var intMenuItem = $.inArray(objMenuItem, objPopupMenu.MenuItems);

    // Remove when found ...
    if (intMenuItem > -1) { objPopupMenu.MenuItems.splice(intMenuItem, 1); }

    // Hide the activation element ...
    if (objPopupMenu.MenuItems.length == 0) { objPopupMenu.ActivationElement.hide(); }
}

// **************************************************************************
// FUNCTION: SetMenuItems
// USAGE:    
// **************************************************************************
SD.PopupMenu.SetMenuItems = function SetMenuItems(arrMenuItems) {

    // Get the instance ...
    var objPopupMenu = this;

    // Set the menu itmes ...
    objPopupMenu.MenuItems = arrMenuItems;

    // Show the activation element when we have items, otherwise hide it ...
    if (arrMenuItems.length > 0) { objPopupMenu.ActivationElement.show(); } else { objPopupMenu.ActivationElement.hide(); }
}

// **************************************************************************
// FUNCTION: ClickHandler
// USAGE:    
// **************************************************************************
SD.PopupMenu.ClickHandler = function ClickHandler(e) {

    // Get the instance ...
    var objPopupMenu = this;

    // Get the target ...
    var objTarget = $(e.target);

    // Get the menu item element if any in which we clicked ...
    var objMenuItemElement = SD.DOM.GetElementOrParentWithAttribute(objTarget, 'MenuItemID');

    // When found ...
    if (objMenuItemElement) {

        // Get the MenuItemID ...
        var strMenuItemID = objMenuItemElement.attr('MenuItemID');

        // When we have a MenuItemClickedFunction function ...
        if (typeof objPopupMenu.MenuItemClickedFunction != 'undefined') {

            // Close the popup ...
            objPopupMenu.Popup.ClosePopup();

            // Call the menu item clicked function with strMenuItemID as parameter ...
            objPopupMenu.MenuItemClickedFunction(strMenuItemID);

            // Get the menu item object ...
            var objMenuItem = objPopupMenu.GetMenuItemByID(strMenuItemID);

            // When it has a click handler ...
            if (objMenuItem.ClickHandler && !objMenuItem.ReadOnly && !objMenuItem.Checked) {

                // Call it ...
                objMenuItem.ClickHandler();
            }
        }
    }
}

// **************************************************************************
// FUNCTION: GetMenuItemByID
// USAGE:    
// **************************************************************************
SD.PopupMenu.GetMenuItemByID = function GetMenuItemByID(strItemID) {

    // Get the instance ...
    var objPopupMenu = this;

    // Start with not found ...
    var objMenuItem = null;

    // Loop through all the menu items ...
    $.each(objPopupMenu.MenuItems, function (intTestMenuItem, objTestMenuItem) {

        // When the ID matches ...
        if (objTestMenuItem.ItemID == strItemID) {

            // Set the menu item to be returned ...
            objMenuItem = objTestMenuItem;
        }
    });

    // Return the item ...
    return objMenuItem;
}

// **************************************************************************
// FUNCTION: GetMenuItemByID
// USAGE:    
// **************************************************************************
SD.PopupMenu.EnableMenuItem = function EnableMenuItem(strItemID, blnEnable) {
    // Get the instance ...
    var objPopupMenu = this;

    // Start with not found ...
    var objMenuItem = objPopupMenu.GetMenuItemByID(strItemID);

    if (objMenuItem && !objMenuItem.GroupSeparator) {
        objMenuItem.ReadOnly = !blnEnable;
    }
}

// **************************************************************************
// FUNCTION: EnableMenuItemChecked
// USAGE:    
// **************************************************************************
SD.PopupMenu.EnableMenuItemChecked = function EnableMenuItemChecked(strItemID, blnCheck) {
    // Get the instance ...
    var objPopupMenu = this;

    // Start with not found ...
    var objMenuItem = objPopupMenu.GetMenuItemByID(strItemID);

    objMenuItem.Checked = blnCheck;

}

// **************************************************************************
// FUNCTION: SetMenuCheckImage
// USAGE:    
// **************************************************************************
SD.PopupMenu.Shared.CreateCheckMenuItem = function CreateCheckMenuItem(strItemID, strItemDescription, fnClickHandler, blnReadOnly, strToolTipWhenReadOnly, blnChecked) {

    return {
        ItemID: strItemID,
        ItemDescription: strItemDescription,
        ClickHandler: ((typeof fnClickHandler !== 'undefined') ? fnClickHandler : null),
        ReadOnly: blnReadOnly ? blnReadOnly : false,
        ToolTipWhenReadOnly: strToolTipWhenReadOnly ? strToolTipWhenReadOnly : '',
        Checked: blnChecked
    };
}


// **************************************************************************
// FUNCTION: CreateMenuItem
// USAGE:    
// **************************************************************************
SD.PopupMenu.Shared.CreateMenuItem = function CreateMenuItem(strItemID, strItemDescription, fnClickHandler, blnReadOnly, strToolTipWhenReadOnly) {

    // Create and return a menu item object ...
    return {
        ItemID: strItemID,
        ItemDescription: strItemDescription,
        ClickHandler: ((typeof fnClickHandler !== 'undefined') ? fnClickHandler : null),
        ReadOnly: blnReadOnly ? blnReadOnly : false,
        ToolTipWhenReadOnly: strToolTipWhenReadOnly ? strToolTipWhenReadOnly : ''
    };
}

// **************************************************************************
// FUNCTION: CreateGroupSeparator
// USAGE:    
// **************************************************************************
SD.PopupMenu.Shared.CreateGroupSeparator = function CreateGroupSeparator() {

    // Create and return a menu item object ...
    return {
        GroupSeparator: true
    };
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the namespace ...
var SD = SD || {};
SD.Sidebar = SD.Sidebar || {
    Shared: {
        NO_TAB_WIDTH: 300,
        SELECTED_TAB_COLOR: 'rgba(230, 230, 250, 0.95)',
        UNSELECTED_TAB_COLOR: 'rgb(176, 196, 222)',
        DEFAULT_NUMBER_OF_FLASHES: 5,
        DEFAULT_FLASH_DURATION_MS: 500
    }
};

// **************************************************************************
// Enums
// **************************************************************************
SD.Sidebar.enumDisplayMethod = {
    NoFadeOrSlide: 'NoFadeOrSlide',
    Slide: 'Slide',
    Fade: 'Fade'
};

// **************************************************************************
// Enums
// **************************************************************************
SD.Sidebar.enumTabActivationMethod = {
    SidebarVisibilityChangedWithoutFadeOrSlide: 'SidebarVisibilityChangedWithoutFadeOrSlide',
    SidebarVisibilityChangedByFading: 'SidebarVisibilityChangedByFading',
    SidebarVisibilityChangedBySliding: 'SidebarVisibilityChangedBySliding',
    TabSelected: 'TabSelected'
};

// **************************************************************************
// Enums
// **************************************************************************
SD.Sidebar.enumVisibilityState = {
    Visible: 'Visible',
    Hidden: 'Hidden',
    HiddenSlidingHandleVisible: 'HiddenSlidingHandleVisible'
};

// **************************************************************************
// FUNCTION: CreateInstance
// USAGE:    
// **************************************************************************
SD.Sidebar.CreateInstance = function CreateInstance(objContainerElement, strUniqueIDPrefix, strInitialTabName) {

    // Create the object that will hold the instance properties ...
    var objSidebar = {
        ContainerElement: objContainerElement,
        UniqueIDPrefix: strUniqueIDPrefix,
        InitialTabName: strInitialTabName,
        TabItems: new Array(),
        CurrentTab: null,
        Handle: null,
        HandleArrow: null,
        HandleActivationDiv: null,
        TabButtonContainerElement: null,
        TabButtonElements: [],
        VisibilityState: SD.Sidebar.enumVisibilityState.Hidden,
        IsBusySliding: false,
        IsFirstTimeShow: true,
        FlashingTab: false,
        FlashTabOnDisplay: null,

        Show: SD.Sidebar.Show,
        Hide: SD.Sidebar.Hide,
        AddTab: SD.Sidebar.AddTab,
        InsertTabAt: SD.Sidebar.InsertTabAt,
        RemoveTab: SD.Sidebar.RemoveTab,
        CreateElements: SD.Sidebar.CreateElements,
        CreateActivationHandle: SD.Sidebar.CreateActivationHandle,
        GetWidth: SD.Sidebar.GetWidth,
        GetHeight: SD.Sidebar.GetHeight,
        PositionSidebarDiv: SD.Sidebar.PositionSidebarDiv,
        CreateOrUpdateTabButtons: SD.Sidebar.CreateOrUpdateTabButtons,
        TabButtonClicked: SD.Sidebar.TabButtonClicked,
        CurrentTabIndex: SD.Sidebar.CurrentTabIndex,
        GetTabIndexForName: SD.Sidebar.GetTabIndexForName,
        GetTabIndexForTabItem: SD.Sidebar.GetTabIndexForTabItem,
        SelectTab: SD.Sidebar.SelectTab,
        SelectFirstTab: SD.Sidebar.SelectFirstTab,
        ShowBySliding: SD.Sidebar.ShowBySliding,
        HideBySliding: SD.Sidebar.HideBySliding,
        ContainerElementResized: SD.Sidebar.ContainerElementResized,
        SortTabItems: SD.Sidebar.SortTabItems,
        FlashTab: SD.Sidebar.FlashTab,
        AnimateTabColor: SD.Sidebar.AnimateTabColor
    };

    // Create the dom elements ...
    objSidebar.CreateElements();

    return objSidebar;
}

// **************************************************************************
// FUNCTION: Show
// USAGE:    enDisplayMethod should be a value from SD.Sidebar.enumDisplayMethod
//           Ignores enDisplayMethod when VisibilityState is 
//           HiddenSlidingHandleVisible (Always slides back in this scenario)
// **************************************************************************
SD.Sidebar.Show = function Show(enDisplayMethod) {

    // Get the instance ...
    var objSidebar = this;

    // When the sidebar is not visible ...
    if (objSidebar.VisibilityState != SD.Sidebar.enumVisibilityState.Visible) {

        // When the first time that the side bar is shown ...
        if (objSidebar.IsFirstTimeShow) {

            // When only one tab ...
            if (objSidebar.TabItems.length == 1) {

                // Select it ...
                objSidebar.SelectTab(objSidebar.TabItems[0]);

            } else {

                // When we have an initial tab to select ...
                if ((typeof objSidebar.InitialTabName != 'undefined') && (objSidebar.InitialTabName)) {

                    // Get the initial tab ...
                    var intInitialTab = objSidebar.GetTabIndexForName(objSidebar.InitialTabName);

                    // Select the initial tab if it's visible otherwise select the first tab ...
                    if (intInitialTab > -1) { objSidebar.SelectTab(objSidebar.TabItems[intInitialTab]); } else { objSidebar.SortTabItems(); objSidebar.SelectTab(objSidebar.TabItems[0]); }
                }
            }

            // Set to not be the first time that the tab is shown ...
            objSidebar.IsFirstTimeShow = false;
        }

        // Get the current visibility state ...
        var enPreviousVisibilityState = objSidebar.VisibilityState;

        // Set to be visible ...
        objSidebar.VisibilityState = SD.Sidebar.enumVisibilityState.Visible;

        // Create or update the tab buttons ...
        objSidebar.CreateOrUpdateTabButtons();

        // When we have a current tab item ...
        if (objSidebar.CurrentTabIndex() >= 0) {

            // Get the current tab item ...
            let objCurrentTabItem = objSidebar.TabItems[objSidebar.CurrentTabIndex()];

            // Fire the tab activated callback for the newly selected tab ...
            if (objCurrentTabItem.Activate != null) { objCurrentTabItem.Activate(objSidebar.SidebarDiv, SD.Sidebar.Shared.TabActivationMethodForDisplayMethodUsed(enDisplayMethod)); }
        }

        // Show (but very transparently) so that the positioning logic could take affect ...
        objSidebar.SidebarDiv.css('opacity', 0.01);
        objSidebar.SidebarDiv.show();

        // Position the sidebar div ...
        objSidebar.PositionSidebarDiv();

        // Hide it again and reset the opactity ...
        objSidebar.SidebarDiv.hide();
        objSidebar.SidebarDiv.css('opacity', 1);

        // When we have any tab items ...
        if (objSidebar.TabItems.length > 0) {

            switch (enPreviousVisibilityState) {
                case SD.Sidebar.enumVisibilityState.Hidden:

                    // Show the sidebar div using the specified display method (fade in when slide were specified) ...
                    switch (enDisplayMethod) {
                        case SD.Sidebar.enumDisplayMethod.NoFadeOrSlide:
                            objSidebar.SidebarDiv.show();
                            break;
                        case SD.Sidebar.enumDisplayMethod.Slide:
                        // Will fade in (no break statement means that this case
                        // will fall through to the next case option below) ...
                        case SD.Sidebar.enumDisplayMethod.Fade:
                            objSidebar.SidebarDiv.fadeIn();
                            break;
                    }
                    break;

                case SD.Sidebar.enumVisibilityState.HiddenSlidingHandleVisible:

                    // Show by sliding ...
                    objSidebar.ShowBySliding(false);
                    break;
            }
        }
    }
}

// **************************************************************************
// FUNCTION: Hide
// USAGE:    enDisplayMethod should be a value from SD.Sidebar.enumDisplayMethod
// **************************************************************************
SD.Sidebar.Hide = function Hide(enDisplayMethod) {

    // Get the instance ...
    var objSidebar = this;

    // When the sidebar is visible ...
    if (objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) {

        // When we have a current tab item ...
        if (objSidebar.CurrentTabIndex() >= 0) {

            // Get the current tab item ...
            let objCurrentTabItem = objSidebar.TabItems[objSidebar.CurrentTabIndex()];

            // Fire the tab deactivated callback for the selected tab ...
            if (objCurrentTabItem.DeActivate != null) { objCurrentTabItem.DeActivate(objSidebar.SidebarDiv, SD.Sidebar.Shared.TabActivationMethodForDisplayMethodUsed(enDisplayMethod)); }
        }

        // Hide the sidebar div using the specified display method ...
        switch (enDisplayMethod) {
            case SD.Sidebar.enumDisplayMethod.NoFadeOrSlide:
                objSidebar.SidebarDiv.hide();
                break;

            case SD.Sidebar.enumDisplayMethod.Fade:
                objSidebar.SidebarDiv.fadeOut();
                break;

            case SD.Sidebar.enumDisplayMethod.Slide:
                objSidebar.HideBySliding(false);
                break;
        }

    }
    else if (objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.HiddenSlidingHandleVisible) {

        switch (enDisplayMethod) {
            case SD.Sidebar.enumDisplayMethod.NoFadeOrSlide:
                objSidebar.SidebarDiv.hide();
                break;

            case SD.Sidebar.enumDisplayMethod.Fade:
            case SD.Sidebar.enumDisplayMethod.Slide:
                objSidebar.SidebarDiv.fadeOut();
                break;
        }

        // Toggle the Handle arrow ...
        objSidebar.HandleArrow.removeClass('sidebar-arrow-left');
        objSidebar.HandleArrow.addClass('sidebar-arrow-right');
    }

    // Set to be not visible ...
    objSidebar.VisibilityState = SD.Sidebar.enumVisibilityState.Hidden;
}

// **************************************************************************
// FUNCTION: AddTab
// USAGE:    objTabItem
//           blnUpdateTabsDisplay is optional, defaults to true
// **************************************************************************
SD.Sidebar.AddTab = function AddTab(objTabItem, blnUpdateTabsDisplay) {

    // Get the instance ...
    var objSidebar = this;

    // Add the tab item to the hashtable ...
    objSidebar.TabItems.push(objTabItem);

    // When we are to update the tabs display ...
    if ((typeof blnUpdateTabsDisplay == 'undefined') || (blnUpdateTabsDisplay == null) || blnUpdateTabsDisplay) {

        // Show SidebarDiv when we have tab items and the side bar is set to be visible and SidebarDiv is invisible ...
        if ((objSidebar.TabItems.length > 0) && (objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) && (!objSidebar.SidebarDiv.is(':visible'))) { objSidebar.SidebarDiv.show(); }

        // Create or update the tab buttons ...
        objSidebar.CreateOrUpdateTabButtons();
    }
}

// **************************************************************************
// FUNCTION: InsertTabAt
// USAGE:    objTabItem
// **************************************************************************
SD.Sidebar.InsertTabAt = function InsertTabAt(objTabItem, intIndex) {

    // Get the instance ...
    var objSidebar = this;

    // Add the tab item to the hashtable ...
    objSidebar.TabItems.splice(intIndex, 0, objTabItem);
}

// **************************************************************************
// FUNCTION: RemoveTab
// USAGE:    blnUpdateTabsDisplay is optional, defaults to true
// **************************************************************************
SD.Sidebar.RemoveTab = function RemoveTab(objTabItem, blnUpdateTabsDisplay) {

    // Get the instance ...
    var objSidebar = this;

    // Get the index for the tab item ...
    var intTab = objSidebar.GetTabIndexForTabItem(objTabItem);

    // When found ...
    if (intTab > -1) {

        // When the tab is currently selected ...
        if (objSidebar.CurrentTabIndex() == intTab) {

            // When we have more than one tabs (i.e. we will haev another tab to select) ...
            if (objSidebar.TabItems.length > 1) {

                // When we have an initial tab to select ...
                if ((typeof objSidebar.InitialTabName != 'undefined') && objSidebar.InitialTabName) {

                    // Get the index for the tab ...
                    var intInitialTab = objSidebar.GetTabIndexForName(objSidebar.InitialTabName);

                    // Select the initial tab when found and is not the tab to remove otherwise select the first tab ...
                    if ((intInitialTab > -1) && (intTab != intInitialTab)) { objSidebar.SelectTab(objSidebar.TabItems[intInitialTab]); } else { objSidebar.SelectFirstTab(objTabItem); }

                } else {

                    // Select the first tab ...
                    objSidebar.SelectFirstTab(objTabItem);
                }

            } else {

                // Fire the tab de-activated event on the current tab ...
                if ((objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) && (objSidebar.CurrentTab.DeActivate != null)) { objSidebar.CurrentTab.DeActivate(objSidebar.SidebarDiv, SD.Sidebar.enumTabActivationMethod.TabSelected); }

                // Set to have no current tab ...
                objSidebar.CurrentTab = null;

                // Set the width and position the sidebar ...
                objSidebar.SidebarDiv.css('width', SD.Sidebar.Shared.NO_TAB_WIDTH + 'px');
                objSidebar.SidebarDiv.css('inset-inline-end', (objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) ? '0px' : -SD.Sidebar.Shared.NO_TAB_WIDTH + 'px');
            }
        }

        // Remove the tab from the tab items array ...
        objSidebar.TabItems.splice(intTab, 1);

        // When we are to update the tabs display ...
        if ((typeof blnUpdateTabsDisplay == 'undefined') || (blnUpdateTabsDisplay == null) || blnUpdateTabsDisplay) {

            // Create or update the tab buttons ...
            objSidebar.CreateOrUpdateTabButtons();

            // Hide SidebarDiv when we have no tab items and the side bar is set to be visible ...
            if ((objSidebar.TabItems.length == 0) && (objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible)) { objSidebar.SidebarDiv.hide(); }
        }
    }
}

// **************************************************************************
// FUNCTION: CreateElements
// USAGE:    
// **************************************************************************
SD.Sidebar.CreateElements = function CreateElements() {

    // Get the instance ...
    var objSidebar = this;

    // Create the sidebar div ...
    objSidebar.SidebarDiv = $('<div id ="' + objSidebar.UniqueIDPrefix + '_SideBar" class="sidebar_div"></div>');

    // Hide the side bar ...
    objSidebar.SidebarDiv.hide();

    // Append it to the container ...
    $(objSidebar.ContainerElement).append(objSidebar.SidebarDiv);

    // Create the activation handle ...
    objSidebar.CreateActivationHandle();
}

// **************************************************************************
// FUNCTION: ContainerElementResized
// USAGE:    
// **************************************************************************
SD.Sidebar.ContainerElementResized = function ContainerElementResized() {

    // Get the instance ...
    var objSidebar = this;

    // Position the sidebar div ...
    objSidebar.PositionSidebarDiv();
}

// **************************************************************************
// FUNCTION: SortTabItems
// USAGE:    
// **************************************************************************
SD.Sidebar.SortTabItems = function SortTabItems() {

    // Get the instance ...
    var objSidebar = this;

    // Sort the atbse according to their order ...
    objSidebar.TabItems = objSidebar.TabItems.sort(function (objTabItemsA, objTabItemsB) { return objTabItemsA.Order - objTabItemsB.Order; });
}

// **************************************************************************
// FUNCTION: CreateOrUpdateTabButtons
// USAGE:    
// **************************************************************************
SD.Sidebar.CreateOrUpdateTabButtons = function CreateOrUpdateTabButtons() {

    // Get the instance ...
    var objSidebar = this;

    // When the sidebar is not hidden ...
    if (objSidebar.VisibilityState != SD.Sidebar.enumVisibilityState.Hidden) {

        // When we have tab items ...
        if (objSidebar.TabItems.length > 0) {

            // Sort the tab items ...
            objSidebar.SortTabItems();

            // When the container element has not been created yet ...
            if (!objSidebar.TabButtonContainerElement) {

                // Create the tab button container ...
                objSidebar.TabButtonContainerElement = $('<div id ="' + objSidebar.UniqueIDPrefix + '_SideBarTabButtonContainer" class="sidebar-tabs"></div>');

                // Attach a clicked event handler for the tab buttons ...
                objSidebar.TabButtonContainerElement.on('click', (function (e) {
                    objSidebar.TabButtonClicked(e);
                }));

            } else {

                // Empty the container ...
                objSidebar.TabButtonContainerElement.empty();
            }

            // Create an array to hold the tab button elements ...
            objSidebar.TabButtonElements = [];

            // Loop through all the tab items ...
            for (var intTabButton = 0; intTabButton < objSidebar.TabItems.length; intTabButton++) {

                // Get the tab item ...
                var objTabItem = objSidebar.TabItems[intTabButton];

                // Create the tab button span ...
                var objTabButtonElementSpan = $('<span id ="' + objSidebar.UniqueIDPrefix + '_SideBarTabButtonSpan_' + objTabItem.Name + '" TabName="' + objTabItem.Name + '">' + objTabItem.Title + '</span>');

                // Measure the span size ...
                var objSpanSize = SD.HtmlFunctions.Shared.MeasureElement(objTabButtonElementSpan);

                // Create the tab button div ...
                var objTabButtonElement = $('<div id ="' + objSidebar.UniqueIDPrefix + '_SideBarTabButton_' + objTabItem.Name + '" class="sidebar-tab"></div>');

                // Set the button element height ...
                objTabButtonElement.height(objSpanSize.width);

                // When this button is for the currently selected tab ...
                if (objSidebar.CurrentTabIndex() == intTabButton) {

                    // Add the selected css class ...
                    objTabButtonElement.addClass('selected');
                }

                // Add the span to the div ...
                objTabButtonElement.append(objTabButtonElementSpan);

                // Add the button div to the button container div ...
                objSidebar.TabButtonContainerElement.append(objTabButtonElement);

                // Add to the list of tab button items ...
                objSidebar.TabButtonElements.push(objTabButtonElement);
            }

            // Add it to the side bar div ...
            objSidebar.SidebarDiv.append(objSidebar.TabButtonContainerElement);

            // When we are to flash the tab on display ...
            if (objSidebar.FlashTabOnDisplay) {

                // Flash the tab ...
                objSidebar.FlashTab(objSidebar.FlashTabOnDisplay.TabItem,
                    objSidebar.FlashTabOnDisplay.NumberOfFlashes,
                    objSidebar.FlashTabOnDisplay.DurationOfEachFlashMs,
                    objSidebar.FlashTabOnDisplay.CompletedFunction);

                // Clear to not flash the next time this function are called ...
                objSidebar.FlashTabOnDisplay = null;
            }

        } else {

            // When we have a tab button container ...
            if (objSidebar.TabButtonContainerElement) {

                // Clear it ...
                objSidebar.TabButtonContainerElement.empty();
            }
        }
    }
}

// **************************************************************************
// FUNCTION: TabButtonClicked
// USAGE:    
// **************************************************************************
SD.Sidebar.TabButtonClicked = function TabButtonClicked(e) {

    // Get the instance ...
    var objSidebar = this;

    // Get the element on which the event were fired ...
    var objEventTarget = $(e.target);

    // Get the side bar button in which the element is on which the event fired ...
    var objSideBarButton = objEventTarget.closest('.sidebar-tab');

    // When found ...
    if (objSideBarButton.length > 0) {

        // Find the hidden field with the tab name ...
        var strName = objSideBarButton.find('span[TabName]').attr('TabName');

        // Get the index of the tab ...
        var intTabIndex = objSidebar.GetTabIndexForName(strName);

        // Select the tab ...
        objSidebar.SelectTab(objSidebar.TabItems[intTabIndex]);

        // When the sidebar were hidden by sliding ...
        if (objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.HiddenSlidingHandleVisible) {

            // Show the sidebar by sliding ...
            objSidebar.ShowBySliding(true);
        }
    }
}

// **************************************************************************
// FUNCTION: SelectTab
// USAGE:    
// **************************************************************************
SD.Sidebar.SelectTab = function SelectTab(objTabItem) {

    // Get the instance ...
    var objSidebar = this;

    // When the tab is not selected already ...
    if (objSidebar.CurrentTab != objTabItem) {

        // Get the current tab and it's index ...
        var objCurrentTab = objSidebar.CurrentTab;
        var intCurrentTab = objSidebar.CurrentTabIndex();

        // Set the new current tab ...
        objSidebar.CurrentTab = objTabItem;

        // When the container element has already been created ...
        if (objSidebar.TabButtonContainerElement) {

            // When we have a selected tab ...
            if (objCurrentTab) {

                // Remove the selected css class from the current tab ...
                objSidebar.TabButtonElements[intCurrentTab].removeClass('selected');

                // Fire the tab de-activated event on the current tab ...
                if ((objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) && (objCurrentTab.DeActivate != null)) { objCurrentTab.DeActivate(objSidebar.SidebarDiv, SD.Sidebar.enumTabActivationMethod.TabSelected); }
            }

            // Get the width of the current tab ...
            var intCurrentTabWidth = objSidebar.GetWidth(objSidebar.CurrentTabIndex());

            // Get the width of the tab to select ...
            var intNewWidth = objSidebar.GetWidth(objSidebar.GetTabIndexForTabItem(objTabItem));

            // Determine the right to animate to ...
            var intNewRight = (objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) ? 0 : -intNewWidth;

            // Use an animation duration of 50ms when the width of the sidebar needs to change ...
            var intDuration = (intNewWidth != intCurrentTabWidth) ? 50 : 0;

            // Animate the left position ...
            objSidebar.SidebarDiv.animate({ width: intNewWidth, "inset-inline-end": intNewRight }, intDuration, function () {

                // Add the selected css class to the current tab ...
                objSidebar.TabButtonElements[objSidebar.CurrentTabIndex()].addClass('selected');

                // Fire the tab activated callback for the newly selected tab ...
                if ((objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) && (objTabItem.Activate != null)) { objTabItem.Activate(objSidebar.SidebarDiv, SD.Sidebar.enumTabActivationMethod.TabSelected); }

                // Position the sidebar div ...
                objSidebar.PositionSidebarDiv();
            });
        }
    }
}

// **************************************************************************
// FUNCTION: SelectFirstTab
// USAGE:    objTabItemToSkip is optional
// **************************************************************************
SD.Sidebar.SelectFirstTab = function SelectFirstTab(objTabItemToSkip) {

    // Get the instance ...
    var objSidebar = this;

    // Start with no tab selected ...
    var blnTabSelected = false;

    // Loop through all the tab items ...
    $.each(objSidebar.TabItems, function (intTabItem, objTabItem) {

        // When not the tab to skip ...
        if (objTabItem != objTabItemToSkip) {

            // Select the tab ...
            objSidebar.SelectTab(objTabItem);

            // Set to have selected the tab ...
            blnTabSelected = true;

            // Stop looping ...
            return false;
        }
    });

    return blnTabSelected;
}

// **************************************************************************
// FUNCTION: GetTabIndexForName
// USAGE:    
// **************************************************************************
SD.Sidebar.GetTabIndexForName = function GetTabIndexForName(strTabName) {

    // Get the instance ...
    var objSidebar = this;

    // Loop through all the tab items ...
    for (var intTabItem = 0; intTabItem < objSidebar.TabItems.length; intTabItem++) {

        // Get the tab item ...
        var objTabItem = objSidebar.TabItems[intTabItem];

        // When the name matches ...
        if (objTabItem.Name == strTabName) {

            // Return the tab index ...
            return intTabItem;
        }
    }

    // Not found ..
    return -1;
}

// **************************************************************************
// FUNCTION: GetTabIndexForTabItem
// USAGE:    Returns the index of the tab (-1 when not found)
// **************************************************************************
SD.Sidebar.GetTabIndexForTabItem = function GetTabIndexForTabItem(objTabItem) {

    // Get the instance ...
    var objSidebar = this;

    // Get the index into the tab items array ...
    var intTab = $.inArray(objTabItem, objSidebar.TabItems);

    // Return the index (-1 when not found) ...
    return intTab;
}

// **************************************************************************
// FUNCTION: CurrentTabIndex
// USAGE:    
// **************************************************************************
SD.Sidebar.CurrentTabIndex = function CurrentTabIndex() {

    // Get the instance ...
    var objSidebar = this;

    // Get the index for the current tab item ...
    var intTab = objSidebar.GetTabIndexForTabItem(objSidebar.CurrentTab);

    // Return the tab index ...
    return intTab;
}

// **************************************************************************
// FUNCTION: GetWidth
// USAGE:    intTabIndex is optional, curernt tab 
//           index will be used when not specified ...
// **************************************************************************
SD.Sidebar.GetWidth = function GetWidth(intTabIndex) {

    // Get the instance ...
    var objSidebar = this;

    // Declare a variable for the return value ...
    var intWidth;

    // When we have tab items ...
    if (objSidebar.TabItems.length > 0) {

        // When no tab index specified, use the current ...
        if (intTabIndex == null) { intTabIndex = objSidebar.CurrentTabIndex() };

        // When we have a tab index ...
        if (intTabIndex > -1) {

            // Get the currently selected tab item ...
            var objTabItem = objSidebar.TabItems[intTabIndex];

            // Get the width of the item width ...
            intWidth = objTabItem.GetWidth();

        } else {

            // Use the NO_TAB_WIDTH ...
            intWidth = SD.Sidebar.Shared.NO_TAB_WIDTH;
        }

    } else {

        // Use the NO_TAB_WIDTH ...
        intWidth = SD.Sidebar.Shared.NO_TAB_WIDTH;
    }

    return intWidth;
}

// **************************************************************************
// FUNCTION: GetHeight
// USAGE:    
// **************************************************************************
SD.Sidebar.GetHeight = function GetHeight() {

    // Get the instance ...
    var objSidebar = this;

    // Return the height of the div ...
    return parseInt(objSidebar.SidebarDiv.innerHeight(), 10);
}

// **************************************************************************
// FUNCTION: PositionSidebarDiv
// USAGE:    
// **************************************************************************
SD.Sidebar.PositionSidebarDiv = function PositionSidebarDiv() {

    // Get the instance ...
    var objSidebar = this;

    // When not busy sliding ...
    if (!objSidebar.IsBusySliding) {

        // Get the width that the sidebar should be ...
        var intWidth = objSidebar.GetWidth();

        // Compute the height ...
        var intHeight = parseInt(objSidebar.ContainerElement.innerHeight(), 10);

        // Move to the right when not visible ...
        var strRight = (objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) ? '0px' : -intWidth + 'px';

        // Position the sidebar on the right of the container element ...
        objSidebar.SidebarDiv.css('inset-block-start', '0px');
        objSidebar.SidebarDiv.css('inset-inline-end', strRight);
        objSidebar.SidebarDiv.css('width', intWidth);
        objSidebar.SidebarDiv.css('height', intHeight);

        // When we have a current tab index ...
        if (objSidebar.CurrentTabIndex() >= 0) {

            // Get the current tab item ...
            var objCurrentTabItem = objSidebar.TabItems[objSidebar.CurrentTabIndex()];

            // Call the resize callback of the current tab item ...
            if (objCurrentTabItem.Resize != null) { objCurrentTabItem.Resize(objSidebar.SidebarDiv); }
        }
    }
}

// **************************************************************************
// FUNCTION: CreateActivationHandle
// USAGE:    
// **************************************************************************
SD.Sidebar.CreateActivationHandle = function CreateActivationHandle() {

    // Get the side bar instance ...
    var objSidebar = this;

    // Create the activation handle activator...
    objSidebar.HandleActivationDiv = $('<div class="sidebar-activation"></div>');

    // Create the handle ...
    objSidebar.Handle = $('<div class="activation-button"></div>');

    // Add the handle to the activator ...
    objSidebar.HandleActivationDiv.append(objSidebar.Handle);

    // Create the arrow ...
    objSidebar.HandleArrow = $('<div class="sidebar-arrow sidebar-arrow-right"></div>');

    // Add the arrow to the handle ...
    objSidebar.Handle.append(objSidebar.HandleArrow);

    // Attach an on mouse enter event handler to the activator ...
    objSidebar.HandleActivationDiv.on('mouseenter', (function () {

        // Animate the handle inward ...
        objSidebar.Handle.animate({ width: 25, 'margin-inline-start': 0 }, 100);
    }));

    // Attach an on mouse leave event handler to the activator ...
    objSidebar.HandleActivationDiv.on('mouseleave', (function () {

        // Animate the handle inward ...
        objSidebar.Handle.animate({ width: 20, 'margin-inline-start': 5 }, 100);
    }));

    // Attach an on mouse click event hanlder to the activator ...
    objSidebar.HandleActivationDiv.on('click', (function () {

        // When the panel is open ...
        if (objSidebar.VisibilityState == SD.Sidebar.enumVisibilityState.Visible) {

            // Hide by by sliding ...
            objSidebar.HideBySliding();

        } else {

            // Show by by sliding ...
            objSidebar.ShowBySliding();
        }
    }));

    // Add it to the side bar div ...
    objSidebar.SidebarDiv.append(objSidebar.HandleActivationDiv);
}

// **************************************************************************
// FUNCTION: ShowBySliding
// USAGE:    
// **************************************************************************
SD.Sidebar.ShowBySliding = function ShowBySliding(blnFireActivationCallback) {

    // Get the side bar instance ...
    var objSidebar = this;

    // Get the left of the a side bar div ...
    var intPanelLeft = objSidebar.SidebarDiv.position().left;

    // Get the width of the side bar div ...
    var intSidebarWidth = objSidebar.GetWidth(objSidebar.CurrentTabIndex());

    // Set to be busy sliding ...
    objSidebar.IsBusySliding = true;

    // Animate the side bar to the left ...
    objSidebar.SidebarDiv.animate({ "inset-inline-end": 0 }, 300, function () {

        // Set to be hidden with the sliding hanlde visible ...
        objSidebar.VisibilityState = SD.Sidebar.enumVisibilityState.Visible;

        // Set to be done sliding ...
        objSidebar.IsBusySliding = false;

        // When blnFireActivationCallback has not been specified ... 
        if (typeof blnFireActivationCallback == 'undefined') {

            // Default it to true ...
            blnFireActivationCallback = true;
        }

        // When we are to fire the activation callback ...
        if (blnFireActivationCallback) {

            // When we have a current tab item ...
            if (objSidebar.CurrentTabIndex() >= 0) {

                // Get the current tab item ...
                let objCurrentTabItem = objSidebar.TabItems[objSidebar.CurrentTabIndex()];

                // Fire the tab activated callback for the newly selected tab ...
                if (objCurrentTabItem.Activate != null) { objCurrentTabItem.Activate(objSidebar.SidebarDiv, SD.Sidebar.enumTabActivationMethod.SidebarVisibilityChangedBySliding); }

                // Position the side bar div ...
                objSidebar.PositionSidebarDiv();
            }
        }
    });

    // Remove the left arrow class ...
    objSidebar.HandleArrow.removeClass('sidebar-arrow-left');
    objSidebar.HandleArrow.addClass('sidebar-arrow-right');
}

// **************************************************************************
// FUNCTION: HideBySliding
// USAGE:    blnFireDeActivationCallback is optional and true by default ...
// **************************************************************************
SD.Sidebar.HideBySliding = function HideBySliding(blnFireDeActivationCallback) {

    // Get the side bar instance ...
    var objSidebar = this;

    // Get the left of the a side bar div ...
    var intPanelLeft = objSidebar.SidebarDiv.position().left;

    // Get the width of the side bar panel  ...
    var intSidebarWidth = objSidebar.GetWidth(objSidebar.CurrentTabIndex());

    // Set to be busy sliding ...
    objSidebar.IsBusySliding = true;

    // Animate the side bar to the right ...
    objSidebar.SidebarDiv.animate({ "inset-inline-end": -intSidebarWidth }, 300, function () {

        // Set to be visible ...
        objSidebar.VisibilityState = SD.Sidebar.enumVisibilityState.HiddenSlidingHandleVisible;

        // Set to be done sliding ...
        objSidebar.IsBusySliding = false;

        // When blnFireDeActivationCallback has not been specified ... 
        if (typeof blnFireDeActivationCallback == 'undefined') {

            // Default it to true ...
            blnFireDeActivationCallback = true;
        }

        // When we are to fire the de-activation callback ...
        if (blnFireDeActivationCallback) {

            // When we have a current tab item ...
            if (objSidebar.CurrentTabIndex() >= 0) {

                // Get the current tab item ...
                let objCurrentTabItem = objSidebar.TabItems[objSidebar.CurrentTabIndex()];

                // Fire the tab deactivated callback for the selected tab ...
                if (objCurrentTabItem.DeActivate != null) { objCurrentTabItem.DeActivate(objSidebar.SidebarDiv, SD.Sidebar.enumTabActivationMethod.SidebarVisibilityChangedBySliding); }
            }
        }
    });

    // Add the left arrow class ...
    objSidebar.HandleArrow.removeClass('sidebar-arrow-right');
    objSidebar.HandleArrow.addClass('sidebar-arrow-left');
}

// **************************************************************************
// FUNCTION: FlashTab
// USAGE:    intNumberOfFlashes is optional, defaults to 3
//           intDurationOfEachFlashMs is optional, defaults to 1000 
// **************************************************************************
SD.Sidebar.FlashTab = function FlashTab(objTabItem, intNumberOfFlashes, intDurationOfEachFlashMs, fnCompleted) {

    // Get the side bar instance ...
    var objSidebar = this;

    // Set the defaults for intNumberOfFlashes and intDurationOfEachFlashMs when not specified ...
    if ((typeof intNumberOfFlashes == 'undefined') && (intNumberOfFlashes == null)) { intNumberOfFlashes = SD.Sidebar.Shared.DEFAULT_NUMBER_OF_FLASHES; }
    if ((typeof intDurationOfEachFlashMs == 'undefined') && (intDurationOfEachFlashMs == null)) { intDurationOfEachFlashMs = SD.Sidebar.Shared.DEFAULT_FLASH_DURATION_MS; }

    // When the sidebar elements has already been created ...
    if (objSidebar.TabButtonContainerElement) {

        // When we are not already flashing a tab ...
        if (!objSidebar.FlashingTab) {

            // Set to be flashing a tab ...
            objSidebar.FlashingTab = true;

            // Get the index for the tab item ...
            var intTab = objSidebar.GetTabIndexForTabItem(objTabItem);

            // Get the tab element ...
            var objTabButtonElement = objSidebar.TabButtonElements[intTab];

            // Get the current color of the tab button ...
            var strCurrentColor = objTabButtonElement.css('background-color');

            // Determine the color to use for the animation ...    
            var strOtherColor = (objTabItem == objSidebar.CurrentTab) ? SD.Sidebar.Shared.UNSELECTED_TAB_COLOR : SD.Sidebar.Shared.SELECTED_TAB_COLOR;

            // Animate the tab color ...
            objSidebar.AnimateTabColor(objTabButtonElement, strCurrentColor, strOtherColor, intNumberOfFlashes, intDurationOfEachFlashMs, fnCompleted);
        }

    } else {

        // Set to flash the tab when the side bar are being displayed ...
        objSidebar.FlashTabOnDisplay = {
            TabItem: objTabItem,
            NumberOfFlashes: intNumberOfFlashes,
            DurationOfEachFlashMs: intDurationOfEachFlashMs,
            CompletedFunction: fnCompleted
        }
    }
}

// **************************************************************************
// FUNCTION: AnimateTabColor
// USAGE:    
// **************************************************************************
SD.Sidebar.AnimateTabColor = function AnimateTabColor(objTabButtonElement, strCurrentColor, strOtherColor, intNumberOfFlashes, intDurationOfEachFlashMs, fnCompleted) {

    // Get the side bar instance ...
    var objSidebar = this;

    // Determine half the duration to anuimate ...
    var intDuration = intDurationOfEachFlashMs / 2;

    // Animate to the other color ...
    objTabButtonElement.animate({ 'background-color': strOtherColor }, intDuration, function () {

        // Animate back to the current color ...
        objTabButtonElement.animate({ 'background-color': strCurrentColor }, intDuration, function () {

            // Remove the background color to fall back to the css colors ... 
            objTabButtonElement.css('background-color', '');

            // Decrease the number of flashes left ...
            intNumberOfFlashes--;

            // When any more flashes left to perform ...
            if (intNumberOfFlashes > 0) {

                // Animate the tab color ...
                objSidebar.AnimateTabColor(objTabButtonElement, strCurrentColor, strOtherColor, intNumberOfFlashes, intDurationOfEachFlashMs);

            } else {

                // Set to not be flashing a tab anymore ...
                objSidebar.FlashingTab = false;

                // Call the completed function when we have one ...
                if ((typeof fnCompleted != 'undefined') && fnCompleted) { fnCompleted(); }
            };
        });
    });
}

// **************************************************************************
// FUNCTION: CreateTabItem
// USAGE:    
// **************************************************************************
SD.Sidebar.Shared.CreateTabItem = function CreateTabItem(strName, strTitle, intTabOrder, fnActivate, fnDeActivate, fnResize, fnGetWidth) {

    // Create the tab item ...
    var objTabItem = {
        Name: strName,
        Title: strTitle,
        Order: intTabOrder,
        Activate: fnActivate,
        DeActivate: fnDeActivate,
        Resize: fnResize,
        GetWidth: fnGetWidth
    };

    return objTabItem;
}

// **************************************************************************
// FUNCTION: TabActivationMethodForDisplayMethodUsed
// USAGE:    enDisplayMethod should be a valeu from SD.Sidebar.enumDisplayMethod
// RETURNS:  SD.Sidebar.enumTabActivationMethod
// **************************************************************************
SD.Sidebar.Shared.TabActivationMethodForDisplayMethodUsed = function TabActivationMethodForDisplayMethodUsed(enDisplayMethod) {

    // Declare a variable for the tab activation method ...
    var enTabActivationMethod;

    // Show the sidebar div using the specified display method (fade in when slide were specified) ...
    switch (enDisplayMethod) {
        case SD.Sidebar.enumDisplayMethod.NoFadeOrSlide:
            enTabActivationMethod = SD.Sidebar.enumTabActivationMethod.SidebarVisibilityChangedWithoutFadeOrSlide;
            break;
        case SD.Sidebar.enumDisplayMethod.Slide:
            enTabActivationMethod = SD.Sidebar.enumTabActivationMethod.SidebarVisibilityChangedBySliding;
            break;
        case SD.Sidebar.enumDisplayMethod.Fade:
            enTabActivationMethod = SD.Sidebar.enumTabActivationMethod.SidebarVisibilityChangedByFading;
            break;
    }

    return enTabActivationMethod;
}
// Create the SD namespace object (if it does not exist already) ...
var SD = SD || {};

// Create the Spatial namespace object (if it does not exist already) ...
SD.Spatial = SD.Spatial || {};

// Create the Projection namespace object ...
SD.Spatial.Functions = SD.Spatial.Functions || {};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SnapToGrid : 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Spatial.Functions.SnapToGrid = function SnapToGrid(objGeometry, decSideLength, decTolerance) {

    // Loop through all the rings ...
    for (var intRing = 0; intRing < objGeometry.rings.length; intRing++) {

        // Get the ring ...
        var objRing = objGeometry.rings[intRing];

        // Loop through all the points ...
        for (var intPoint = 0; intPoint < objRing.length; intPoint++) {

            // Get the point ...
            var objPoint = objRing[intPoint];

            // Snape the x and y values to the side length ...
            objPoint[0] = SD.Spatial.Functions.SnapToMultiple(objPoint[0], decSideLength, decTolerance);
            objPoint[1] = SD.Spatial.Functions.SnapToMultiple(objPoint[1], decSideLength, decTolerance);
        }
    }
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SnapToMultiple: 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Spatial.Functions.SnapToMultiple = function SnapToMultiple(decValue, decSideLength, decTolerance) {

    // Compute the modulus of decValue and decSideLength ...
    var decModulus = decValue % decSideLength;

    // Declare a variable for the snapped value to return ...
    var decSnappedValue = decValue;

    // When smaller than the side length ...
    if (decModulus < decTolerance) {

        // Snap the value downwards ...
        decSnappedValue = SD.Number.Truncate(decValue / decSideLength) * decSideLength;

        // When within decTolerance of the decSideLength ...
    } else if (decModulus > (decSideLength - decTolerance)) {

        // Snap the value upwards ...
        decSnappedValue = (SD.Number.Truncate(decValue / decSideLength) + 1) * decSideLength;
    }

    return decSnappedValue;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION FixWindingOrder: This function assumes the geometry only has exterior rings and no holes ...
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Spatial.Functions.FixWindingOrder = function FixWindingOrder(objGeometry) {

    // Loop through all the rings ...
    for (var intRing = 0; intRing < objGeometry.rings.length; intRing++) {

        // Get the ring ...
        var objRing = objGeometry.rings[intRing];

        // Start with no area ...
        var dblArea = 0;

        // Loop through all the points of the ring ...
        for (var intPoint = 0; intPoint < objRing.length; intPoint++) {

            // Get the point ...
            var objPoint = objRing[intPoint];

            // Get next the point ...
            var objNextPoint = objRing[(intPoint + 1) % objRing.length];

            // Add to the area ...
            dblArea += (objPoint[0] * objNextPoint[1]) - (objNextPoint[0] * objPoint[1]);
        }

        // When the area is negative the ring should be reversed ...
        if (dblArea >= 0) {

            // Reverse the order of the coordinates in the array ...
            objRing.reverse();            
        }
    }
}


// Create the SD namespace object (if it does not exist already) ...
var SD = SD || {};

// Create the Spatial namespace object (if it does not exist already) ...
SD.Spatial = SD.Spatial || {};

// Create the Projection namespace object ...
SD.Spatial.Projection = SD.Spatial.Projection || {};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ProjectCoordinates : Projects the coordinate from the "From" spatial 
//                               reference to the "To" spatial reference ... 
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Spatial.Projection.ProjectCoordinates = function ProjectCoordinates(objGeometry, objFromProj4jsProjection, objToProj4jsProjection) {

    // Depending on the geometry type ...
    switch (objGeometry.type) {
        case 'polygon':

            // Loop through all the rings ...
            for (var intRing = 0; intRing < objGeometry.rings.length; intRing++) {

                // Get the ring ...
                var arrRingPoints = objGeometry.rings[intRing];

                // Loop through all the coordinates ...
                for (var intCoordinate = 0; intCoordinate < arrRingPoints.length; intCoordinate++) {

                    /// Get the coordinate ...
                    var objCoordinate = arrRingPoints[intCoordinate];

                    // Construct a new proj4.Point from the coordinate ...
                    var objPoint = new proj4.Point(objCoordinate[0], objCoordinate[1]);

                    // Transform the point  ...
                    proj4.transform(objFromProj4jsProjection, objToProj4jsProjection, objPoint);

                    // Place the projected point back into the coordinate ...
                    objCoordinate[0] = objPoint.x;
                    objCoordinate[1] = objPoint.y;
                }
            }
            break;

        case 'multipoint':

            // Loop through all the coordinates ...
            for (var intCoordinate = 0; intCoordinate < objGeometry.points.length; intCoordinate++) {

                /// Get the coordinate ...
                var objCoordinate = objGeometry.points[intCoordinate];

                // Construct a new proj4.Point from the coordinate ...
                var objPoint = new proj4.Point(objCoordinate[0], objCoordinate[1]);

                // Transform the point  ...
                proj4.transform(objFromProj4jsProjection, objToProj4jsProjection, objPoint);

                // Place the projected point back into the coordinate ...
                objCoordinate[0] = objPoint.x;
                objCoordinate[1] = objPoint.y;
            }
            break;

        case 'point':

            // Construct a new proj4.Point from the coordinate ...
            var objPoint = new proj4.Point(objGeometry.x, objGeometry.y);

            // Transform the point  ...
            proj4.transform(objFromProj4jsProjection, objToProj4jsProjection, objPoint);

            // Place the projected point back into the geometry ...
            objGeometry.x = objPoint.x;
            objGeometry.y = objPoint.y;
            break;
    }
}

// **************************************************************************
// FUNCTION: ScreenPointToCoordinateSR
// USAGE:    Convert the screen point to an arc 1950 map coordinate ...
// **************************************************************************
SD.Spatial.Projection.ScreenPointToCoordinateSR = function ScreenPointToCoordinateSR(decX, decY, objExtent, intMapScreenWidth, intMapScreenHeight, objMapProj4jsSpatialReference, objCoordinatesProj4jsSpatialReference) {

    // Build an esri point for the x y screen coordinate ...
    var objScreenPoint = new esri.geometry.Point(decX, decY);

    // Convert the screen point to map spatial reference ...
    var objMapPoint = esri.geometry.toMapPoint(objExtent, intMapScreenWidth, intMapScreenHeight, objScreenPoint);

    // Convert to wgs84 ...
    var objWgs84Point = esri.geometry.webMercatorToGeographic(objMapPoint);

    // Project the coordinate from wgs84 to the coordinate spatial reference web mercator ...
    var objCoordinateSRPoint = proj4.transform(objMapProj4jsSpatialReference, objCoordinatesProj4jsSpatialReference, objWgs84Point);

    // Return the point in arc 1950 ...
    return objCoordinateSRPoint;
}

SD.Spatial.Projection.ProjectCoordinate = function ProjectCoordinate(decX, decY, objFromProj4jsProjection, objToProj4jsProjection) {

    // Construct a new proj4.Point from the coordinate ...
    var objPoint = new proj4.Point(decX, decY);

    // Transform the point  ...
    proj4.transform(objFromProj4jsProjection, objToProj4jsProjection, objPoint);

    return objPoint;
}


/// <reference path="~/JavaScript/jquery.js" />

// Create the SD namespace (if it does not exist already) ...
var SD = SD || {};

// Create the Spinner namespace ... (if it does not exist already) ...
SD.SpinnerFunctions = SD.SpinnerFunctions || { Shared: {} };

// **************************************************************************
// FUNCTION: CreateSpinner
// USAGE:    Creates the animated spinner ...
// **************************************************************************
SD.SpinnerFunctions.Shared.CreateSpinner = function CreateSpinner(objTarget, intInnerRadius, intFullRadius, intLineCount, intStrokeWidth, strColor) {

    var objSpinnerOptions = {
        lines: intLineCount, // The number of lines to draw
        length: intFullRadius - intInnerRadius, // The length of each line
        width: intStrokeWidth, // The line thickness
        radius: intInnerRadius, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: strColor, // #rgb or #rrggbb or array of colors
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        "inset-block-start": '50%', // Top position relative to parent
        "inset-inline-start": '50%' // Left position relative to parent
    };

    // Create the spinner ...
    var objSpinner = new Spinner(objSpinnerOptions).spin(objTarget.get(0));
}

// **************************************************************************
// FUNCTION: CreateSpinnerInContainerElement
// USAGE:    Creates the animated spinner withing the container element ...
// **************************************************************************
SD.SpinnerFunctions.Shared.CreateSpinnerInContainerElement = function CreateSpinnerInContainerElement(objContainerElement, intInnerRadius, intFullRadius, intLineCount, intStrokeWidth, strColor, strText, strTextCssClass, strGroupingDivCssClass) {

    // Get the id of the containing element ...
    var strContainerElementID = objContainerElement.attr('id');

    // Create a new grouping div ...
    var objGroupingDiv = $("<div class='" + strGroupingDivCssClass + "'></div>");

    // Add the grouping div to the container ...
    objContainerElement.append(objGroupingDiv);

    // Create the spinner div's id ...
    var strSpinnerDivID = strContainerElementID + "_SpinnerDiv";

    // Create a new spinner div ...
    var objSpinnerDiv = $("<div id='" + strSpinnerDivID + "'></div>");

    // Add the spinner div to the container ...
    objGroupingDiv.append(objSpinnerDiv);

    // Create the animated spinner ...
    SD.SpinnerFunctions.Shared.CreateSpinner(objSpinnerDiv, intInnerRadius, intFullRadius, intLineCount, intStrokeWidth, strColor);

    // Create a text element to place below the spinner ...
    var objTextElement = $('<span class="' + strTextCssClass + '">' + strText + '</span>');

    // Add it to the grouping div ...
    objGroupingDiv.append(objTextElement);

    // Compute teh size of the text element on the display ...
    var objTextSize = SD.HtmlFunctions.Shared.MeasureElement(objTextElement);

    // Compute the width and height for teh grouping div ...
    var intGroupingDivWidth = objTextSize.width;
    var intGroupingDivHeight = objTextSize.height + (intFullRadius * 2) + 10;

    // Set the grouping div's width and height ...
    objGroupingDiv.css('width', intGroupingDivWidth);
    objGroupingDiv.css('height', intGroupingDivHeight);

    // Position the spinner in the center of the container ...
    objSpinnerDiv.css('position', 'relative');
    objSpinnerDiv.css('inset-inline-start', '0px');
    objSpinnerDiv.css('inset-block-start', (intFullRadius) + 'px');

    // Position the text element ...
    objTextElement.css('position', 'relative');
    objTextElement.css("inset-inline-start", '0px');
    objTextElement.css("inset-block-start", ((intFullRadius * 2) + 10) + 'px');

    // Create the spinner elements ...
    var objSpinnerElements = {
        ContainerElement: objContainerElement,
        SpinnerDiv: objSpinnerDiv,
        TextElement: objTextElement,
        StrokeWidth: intStrokeWidth,
        FullRadius: intFullRadius,
        GroupingDiv: objGroupingDiv,
        GroupingDivWidth: intGroupingDivWidth,
        GroupingDivHeight: intGroupingDivHeight
    };

    // Position the spinner in the container element ...
    SD.SpinnerFunctions.Shared.PositionSpinnerInContainerElement(objSpinnerElements);

    // Return the spinner elements ...
    return objSpinnerElements;
}

// **************************************************************************
// FUNCTION: PositionSpinnerInContainerElement
// USAGE:    
// **************************************************************************
SD.SpinnerFunctions.Shared.PositionSpinnerInContainerElement = function PositionSpinnerInContainerElement(objSpinnerElements) {

    // Get the container element position and size ...
    let intContainerElementWidth = objSpinnerElements.ContainerElement.innerWidth();
    let intContainerElementHeight = objSpinnerElements.ContainerElement.innerHeight();
    let intInlineStart = (intContainerElementWidth / 2) - (parseInt(objSpinnerElements.GroupingDiv.outerWidth(), 10) / 2);
    let intBlockStart = (intContainerElementHeight / 2) - (parseInt(objSpinnerElements.GroupingDiv.outerHeight(), 10) / 2);

    // Position the spinner in the center of the container ...
    objSpinnerElements.GroupingDiv.css('position', 'absolute');
    objSpinnerElements.GroupingDiv.css('inset-inline-start', intInlineStart + 'px');
    objSpinnerElements.GroupingDiv.css('inset-block-start', intBlockStart + 'px');
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the Map namespace ...
SD.String = SD.String || {};

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION ZeroPad
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.String.ZeroPad = function ZeroPad(strValue, intCharacters) {

    // While we do not have the target number of characters in our value string ...
    while (strValue.length < intCharacters) {

        // Zeropad from the front ...
        strValue = '0' + strValue;
    }

    return strValue;
}


// Create the SD namespace object (if it does not exist already) ...
var SD = SD || {};

// Create the name space ...
SD.Translation = SD.Translation || { 
    Shared: {
        // Translations that were built up on the server side like on AssetApplication.aspx.vb.
        PrimaryTranslationHandlers: [],
        // Translations that are static and exist within other handlers like Map.TranslationHandler.
        SecondaryTranslationHandlers: []
    } 
}

// **************************************************************************
// FUNCTION: GetTranslation
// USAGE:    
// **************************************************************************
SD.Translation.Shared.GetTranslation = function GetTranslation(strJSFilename, strInterfaceResource) {

    // Start with not found ...
    var strTranslation = null;

    // Loop through all the translation handlers ...
    $.each(SD.Translation.Shared.PrimaryTranslationHandlers, function (intTranslationHandler, fnTranslationHandler) {

        // Call the translation handler to get the translation ...
        var strTranslationHandlerResult = fnTranslationHandler(strJSFilename, strInterfaceResource);

        // When the handler returned the validation result ...
        if (strTranslationHandlerResult && (strTranslationHandlerResult).trim().length > 0) {

            // Set the translation to the result ...
            strTranslation = strTranslationHandlerResult;

            // Exit the each loop ...
            return false;
        }
    });

    if (!strTranslation) {
        // Loop through all the translation handlers ...
        $.each(SD.Translation.Shared.SecondaryTranslationHandlers, function (intTranslationHandler, fnTranslationHandler) {

            // Call the translation handler to get the translation ...
            var strTranslationHandlerResult = fnTranslationHandler(strJSFilename, strInterfaceResource);

            // When the handler returned the validation result ...
            if (strTranslationHandlerResult && (strTranslationHandlerResult).trim().length > 0) {

                // Set the translation to the result ...
                strTranslation = strTranslationHandlerResult;

                // Exit the each loop ...
                return false;
            }
        });
    }

    // Set to 'Translation not found' when not found ...
    strTranslation = (strTranslation != null) ? strTranslation : 'Translation not found';
    
    // When any additional parameters were passed in ...
    if (arguments.length > 2 && strTranslation) {

        // Loop through all the additional arguments ...
        for (var intArgument = 0; intArgument < arguments.length - 2; intArgument++) {

            // Get the argument value at the index ...
            var strArgument = arguments[intArgument + 2];

            // Build the token string to be replaced with the argument ...
            var strReplacementToken = '%' + (intArgument + 1);

            // Replace the token with the argument value ... 
            strTranslation = strTranslation.replace(strReplacementToken, strArgument);
        }
    }

    return strTranslation;
}

// **************************************************************************
// FUNCTION: RegisterPrimaryTranslationHandler
// USAGE:    fnTranslationHandler should be a function with the following signature:
//           GetTranslation(strJSFilename, strInterfaceResource)
// **************************************************************************
SD.Translation.Shared.RegisterPrimaryTranslationHandler = function RegisterPrimaryTranslationHandler(fnTranslationHandler) {

    // Add the translation handler to the list of translations ...
    SD.Translation.Shared.PrimaryTranslationHandlers.push(fnTranslationHandler);
}

// **************************************************************************
// FUNCTION: RegisterSecondaryTranslationHandler
// USAGE:    fnTranslationHandler should be a function with the following signature:
//           GetTranslation(strJSFilename, strInterfaceResource)
// **************************************************************************
SD.Translation.Shared.RegisterSecondaryTranslationHandler = function RegisterSecondaryTranslationHandler(fnTranslationHandler) {

    // Add the translation handler to the list of translations ...
    SD.Translation.Shared.SecondaryTranslationHandlers.push(fnTranslationHandler);
}

// **************************************************************************
// FUNCTION: ClearHandlers
// USAGE:    
// **************************************************************************
SD.Translation.Shared.ClearHandlers = function ClearHandlers() {

    // Clear the hanlders array ...
    SD.Translation.Shared.PrimaryTranslationHandlers = [];
    SD.Translation.Shared.SecondaryTranslationHandlers = [];
}


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the TranslationHandler namespace ...
SD.TranslationHandler = SD.TranslationHandler || { Shared: {} };

// **************************************************************************
// Constructor
// **************************************************************************
SD.TranslationHandler.CreateInstance = function CreateInstance() {

    // Create the instance ...
    var objTranslationHandler = {
        GetTranslationProxy: function (strJSFilename, strInterfaceResource) { return objTranslationHandler.GetTranslation(strJSFilename, strInterfaceResource); },
        GetTranslation: SD.TranslationHandler.GetTranslation
    };

    return objTranslationHandler;
}

// **************************************************************************
// FUNCTION GetTranslation
// **************************************************************************
SD.TranslationHandler.GetTranslation = function GetTranslation(strJSFilename, strInterfaceResource) {

    // Get the instance ...
    var objTranslationHandler = this;

    switch (strJSFilename) {
        case 'SD.DMS.js':
            switch (strInterfaceResource) {
                case 'EastAbbreviation': return 'E';
                case 'NorthAbbreviation': return 'N';
                case 'SouthAbbreviation': return 'S';
                case 'WestAbbreviation': return 'W';
            }
            break;

        case 'SD.PopupMenu.js':
            switch (strInterfaceResource) {
                case 'MenuItemDisabled': return 'This tool is not available while the shape is not in edit mode';
            }
            break;
    }
}

// **************************************************************************
// FUNCTION Register
// **************************************************************************
SD.TranslationHandler.Shared.Register = function Register() {

    // Create a map traslation handler and register it ...
    SD.Translation.Shared.RegisterSecondaryTranslationHandler(SD.TranslationHandler.CreateInstance().GetTranslationProxy);
}

// **************************************************************************
// FUNCTION Register this TranslationHandler ...
// **************************************************************************
SD.TranslationHandler.Shared.Register();


/// <reference path="~/JavaScript/jquery.js" />
/// <reference path="~/JavaScript/esri/jsapi_vsdoc_v32_2010.js" />

// Create the Url namespace ...
SD.Url = SD.Url || { Shared: {} };

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION IsValidURL
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Url.Shared.IsValidURL = function IsValidURL(strUrl) {

    // Create a regular exporession to test with ...
    var objRegex = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;

    // Test the string ...
    return objRegex.test(strUrl);
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION GetCurrentWebSitePath
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Url.Shared.GetCurrentWebSitePath = function GetCurrentWebSitePath() {

    // Start with the protocol ...
    var strCurrentWebSiteUrl = window.location.protocol;

    // Add the hostname ...
    strCurrentWebSiteUrl += '//' + window.location.hostname;

    // Add the port number when not the default port ...
    if ((window.location.port != '') && (window.location.port != '80')) { strCurrentWebSiteUrl += ':' + window.location.port; }

    // Add another front slash ...
    strCurrentWebSiteUrl += '/';
    
    // When the page has a path name (this is just a precaution, we do not ever expect this to be null) ...
    if (window.location.pathname != null) {

        // Get the current page's url and trim the white spaces ...
        var strPathName = (window.location.pathname).trim();

        // When not an empty string (this is just a precaution, we do not ever expect this to be an empty string) ...
        if (strPathName.length > 0) {

            // Split the string at the ? query string character ...
            var arrPageUrlPartsWithArguments = strPathName.split('?');

            // Get the page url without the url arguments ...
            var strPathName = arrPageUrlPartsWithArguments[0];

            // Remove the whitespace if any ...
            strPathName = (strPathName).trim();

            // When the url has anything before the ? ...
            if (strPathName.length > 0) {

                // Split the string at / ...
                var arrPathNameParts = strPathName.split('/');

                // Loop through all the url parts except the last part ...
                for (let intUrlPart = 0; intUrlPart < arrPathNameParts.length - 1; intUrlPart++) {

                    // Get the part ...
                    var strPathNamePart = arrPathNameParts[intUrlPart];

                    // Add the part to the url ...
                    if (strPathNamePart.length > 0) { strCurrentWebSiteUrl += strPathNamePart + '/'; }
                }
            }
        }
    }

    return strCurrentWebSiteUrl;
}

// FUNCTION GetCurrentWebSitePath
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Url.Shared.GetCurrentWebSitePathForMappingLibrary = function GetCurrentWebSitePathForMappingLibrary() {

    // Start with the protocol ...
    var strCurrentWebSiteUrl = window.location.protocol;

    // Add the hostname ...
    strCurrentWebSiteUrl += '//' + window.location.hostname;

    // Add the port number when not the default port ...
    if ((window.location.port != '') && (window.location.port != '80')) { strCurrentWebSiteUrl += ':' + window.location.port; }

    // Add another front slash ...
    strCurrentWebSiteUrl += '/';

    // When the page has a path name (this is just a precaution, we do not ever expect this to be null) ...
    if (window.location.pathname != null) {

        // Get the current page's url and trim the white spaces ...
        var strPathName = (window.location.pathname).trim();

        // When not an empty string (this is just a precaution, we do not ever expect this to be an empty string) ...
        if (strPathName.length > 0) {

            // Split the string at the ? query string character ...
            var arrPageUrlPartsWithArguments = strPathName.split('?');

            // Get the page url without the url arguments ...
            var strPathName = arrPageUrlPartsWithArguments[0];

            // Remove the whitespace if any ...
            strPathName = (strPathName).trim();

            // When the url has anything before the ? ...
            if (strPathName.length > 0) {

                // Split the string at / ...
                var arrPathNameParts = strPathName.split('/');

                // Get the part ...
                var strPathNamePart = arrPathNameParts[1];

                // Add the part to the url ...
                if (strPathNamePart.length > 0) { strCurrentWebSiteUrl += strPathNamePart + '/'; }
            }
        }
    }

    return strCurrentWebSiteUrl;
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION LandfolioMappingLibraryURL
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Url.Shared.LandfolioMappingLibraryURL = function LandfolioMappingLibraryURL() {
    let strHtmlCollection = document.head.getElementsByTagName('base');
	let strCurrentWebSiteUrl = "";
	
	if (strHtmlCollection && strHtmlCollection.length > 0)
	{
		//this is done to handle the dynamic urls in angular in LFF
		strCurrentWebSiteUrl = strHtmlCollection[0].baseURI;
	}
	else
	{
		//the original way of getting the website url in other products
		strCurrentWebSiteUrl = SD.Url.Shared.GetCurrentWebSitePathForMappingLibrary();
	}
    return strCurrentWebSiteUrl + "Javascript/MappingLibrary/src/MappingLibrary";
}

// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// FUNCTION SetCurrentMappingLibraryURL
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
// Description
// Sets the current url for the mapping library within the application.
// Needed for the images and documents used within the mapping library.
// O+ -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- -=-=-=-=- +O
SD.Url.Shared.SetCurrentMappingLibraryURL = function SetCurrentMappingLibraryURL(strRelativePath) {
    SD.Url.Shared.CurrentMappingLibraryURL = SD.Url.Shared.GetCurrentWebSitePath() + strRelativePath;
}

// Global variables ...
SD.Url.Shared.CurrentMappingLibraryURL = SD.Url.Shared.LandfolioMappingLibraryURL();


export var SD = SD;